filterData('Baseball Hall of Fame/Baseball Hall of Fame/Al Kaline');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Al Lopez');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Barry Larkin');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Bill Mazeroski');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Billy Williams');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Bob Feller');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Brooks Robinson');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Bruce Sutter');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Cal Ripken Jr');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Catfish Hunter');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Dave Winfield');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Don Sutton');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Duke Snider');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Earl Weaver');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Eddie Mathews');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Eddie Murray');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Enos Slaughter');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Fergie Jenkins');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Gary Carter');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/George Brett');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Harmon Kilebrew');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Hoyt Wilhelm');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Jim Bunning');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Jim Palmer');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Johnny Bench');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Juan Marichal');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Larry Doby');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Lou Boudreau');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Lou Brock');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Nolan Ryan');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Orlando Cepeda');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Ozzie Smith');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Paul Molitor');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Phil Niekro');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Phil Rizzuto');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Red Schoendienst');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Reggie Jackson');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Rich Gossage');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Roberto Alomar');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Robin Roberts');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Robin Yount');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Rod Carew');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Rollie Fingers');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Ryne Sandberg');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Tom Lasorda');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Tom Seaver');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Tommy Lasorda');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Tony Gwynn');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Tony Perez');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Wade Boggs');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Warren Spahn');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Whitey Ford');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Willie McCovey');
filterData('Baseball Hall of Fame/Baseball Hall of Fame/Willie Stargell');
filterData('Baseball/Arizona/AJ Pollock');
filterData('Baseball/Arizona/David Peralta');
filterData('Baseball/Arizona/Jean Segura');
filterData('Baseball/Arizona/Patrick Corbin');
filterData('Baseball/Arizona/Paul Goldschmidt');
filterData('Baseball/Arizona/Robbie Ray');
filterData('Baseball/Arizona/Shelby Miller');
filterData('Baseball/Arizona/Zack Greinke');
filterData('Baseball/Atlanta/Arodys Vizcaino');
filterData('Baseball/Atlanta/Ender Inciarte');
filterData('Baseball/Atlanta/Freddie Freeman');
filterData('Baseball/Atlanta/Gordon Beckham');
filterData('Baseball/Atlanta/Jason Grilli');
filterData('Baseball/Atlanta/Julio Teheran');
filterData('Baseball/Atlanta/Mallex Smith');
filterData('Baseball/Atlanta/Nick Markakis');
filterData('Baseball/Baltimore/Chris David');
filterData('Baseball/Baltimore/Kevin Gausman');
filterData('Baseball/Baltimore/Manny Machado');
filterData('Baseball/Baltimore/Mark Trumbo');
filterData('Baseball/Baltimore/Matt Wieters');
filterData('Baseball/Baltimore/Ubaldo Jimenez');
filterData('Baseball/Boston/Clay Buchholz');
filterData('Baseball/Boston/Craig Kimbrel');
filterData('Baseball/Boston/David Ortiz');
filterData('Baseball/Boston/David Price');
filterData('Baseball/Boston/Dustin Pedroia');
filterData('Baseball/Boston/Jackie Bradley Jr');
filterData('Baseball/Boston/Jackie Bradley');
filterData('Baseball/Boston/Koji Uehara');
filterData('Baseball/Boston/Mookie Betts');
filterData('Baseball/Boston/Pablo Sandoval');
filterData('Baseball/Boston/Steven Wright');
filterData('Baseball/Boston/Travis Shaw');
filterData('Baseball/Boston/Xander Bogaerts');
filterData('Baseball/Chicago/Adam Eaton');
filterData('Baseball/Chicago/Addison Russell');
filterData('Baseball/Chicago/Albert Almora');
filterData('Baseball/Chicago/Anthony Rizzo');
filterData('Baseball/Chicago/Ben Zobrist');
filterData('Baseball/Chicago/Brett Lawrie');
filterData('Baseball/Chicago/Chris Sale');
filterData('Baseball/Chicago/David Ross');
filterData('Baseball/Chicago/Dexter Fowler');
filterData('Baseball/Chicago/Jake Arrieta');
filterData('Baseball/Chicago/Jason Hammel');
filterData('Baseball/Chicago/Jason Heyward');
filterData('Baseball/Chicago/Javier Baez');
filterData('Baseball/Chicago/John Danks');
filterData('Baseball/Chicago/Jon Lester');
filterData('Baseball/Chicago/Jorge Soler');
filterData('Baseball/Chicago/Jose Abreu');
filterData('Baseball/Chicago/Jose Quintana');
filterData('Baseball/Chicago/Justin Grimm');
filterData('Baseball/Chicago/Kris Bryant');
filterData('Baseball/Chicago/Kyle Hendricks');
filterData('Baseball/Chicago/Kyle Schwarber');
filterData('Baseball/Chicago/Melky Cabrera');
filterData('Baseball/Chicago/Todd Frazier');
filterData('Baseball/Chicago/Willson Contreras');
filterData('Baseball/Cincinnati/Adam Duvall');
filterData('Baseball/Cincinnati/Billy Hamilton');
filterData('Baseball/Cincinnati/Brandon Phillips');
filterData('Baseball/Cincinnati/Eugenio Suarez');
filterData('Baseball/Cincinnati/Homer Bailey');
filterData('Baseball/Cincinnati/Jay Bruce');
filterData('Baseball/Cincinnati/Joey Votto');
filterData('Baseball/Cincinnati/Zack Cozart');
filterData('Baseball/Cleveland/Carlos Carrasco');
filterData('Baseball/Cleveland/Corey Kluber');
filterData('Baseball/Cleveland/Danny Salazar');
filterData('Baseball/Cleveland/Francisco Lindor');
filterData('Baseball/Cleveland/Jason Kipnis');
filterData('Baseball/Cleveland/Josh Tomlin');
filterData('Baseball/Cleveland/Michael Brantley');
filterData('Baseball/Cleveland/Mike Napoli');
filterData('Baseball/Colorado/Ben Paulsen');
filterData('Baseball/Colorado/Carlos Gonzalez');
filterData('Baseball/Colorado/Charlie Blackmon');
filterData('Baseball/Colorado/DJ LeMahieu');
filterData('Baseball/Colorado/Jose Reyes');
filterData('Baseball/Colorado/Nick Hundley');
filterData('Baseball/Colorado/Nolan Arenado');
filterData('Baseball/Colorado/Trevor Story');
filterData('Baseball/Colorado/Tyler Anderson');
filterData('Baseball/Detroit/Anibal Sanchez');
filterData('Baseball/Detroit/Francisco Rodriguez');
filterData('Baseball/Detroit/Ian Kinsler');
filterData('Baseball/Detroit/JD Martinez');
filterData('Baseball/Detroit/Jarrod Saltalamacchia');
filterData('Baseball/Detroit/Jordan Zimmermann');
filterData('Baseball/Detroit/Justin Upton');
filterData('Baseball/Detroit/Justin Verlander');
filterData('Baseball/Detroit/Miguel Cabrera');
filterData('Baseball/Detroit/Nick Castellanos');
filterData('Baseball/Detroit/Victor Martinez');
filterData('Baseball/Houston/Carlos Correa');
filterData('Baseball/Houston/Carlos Gomez');
filterData('Baseball/Houston/Colby Rasmus');
filterData('Baseball/Houston/Dallas Keuchel');
filterData('Baseball/Houston/Evan Gattis');
filterData('Baseball/Houston/George Springer');
filterData('Baseball/Houston/Jose Altuve');
filterData('Baseball/Houston/Lance McCullers');
filterData('Baseball/Houston/Tyler White');
filterData('Baseball/Kansas City/Alcides Escobar');
filterData('Baseball/Kansas City/Alex Gordon');
filterData('Baseball/Kansas City/Edinson Volquez');
filterData('Baseball/Kansas City/Eric Hosmer');
filterData('Baseball/Kansas City/Lorenzo Cain');
filterData('Baseball/Kansas City/Mike Moustakas');
filterData('Baseball/Kansas City/Salvador Perez');
filterData('Baseball/Kansas City/Wade Davis');
filterData('Baseball/Los Angeles/Adrian Gonzalez');
filterData('Baseball/Los Angeles/Albert Pujols');
filterData('Baseball/Los Angeles/Andrelton Simmons');
filterData('Baseball/Los Angeles/Carl Crawford');
filterData('Baseball/Los Angeles/Chase Utley');
filterData('Baseball/Los Angeles/Clayton Kershaw');
filterData('Baseball/Los Angeles/Corey Seager');
filterData('Baseball/Los Angeles/Enrique Hernandez');
filterData('Baseball/Los Angeles/Garrett Richards');
filterData('Baseball/Los Angeles/Hector Santiago');
filterData('Baseball/Los Angeles/Huston Street');
filterData('Baseball/Los Angeles/Jered Weaver');
filterData('Baseball/Los Angeles/Joc Pederson');
filterData('Baseball/Los Angeles/Julio Urias');
filterData('Baseball/Los Angeles/Justin Turner');
filterData('Baseball/Los Angeles/Kenta Maeda');
filterData('Baseball/Los Angeles/Mike Trout');
filterData('Baseball/Los Angeles/Yasiel Puig');
filterData('Baseball/Miami/Chris Johnson');
filterData('Baseball/Miami/Christian Yelich');
filterData('Baseball/Miami/Dee Gordon');
filterData('Baseball/Miami/Giancarlo Stanton');
filterData('Baseball/Miami/Ichiro Suzuki');
filterData('Baseball/Miami/Jose Fernandez');
filterData('Baseball/Miami/Marcell Ozuna');
filterData('Baseball/Miami/Martin Prado');
filterData('Baseball/Milwaukee/Chris Carter');
filterData('Baseball/Milwaukee/Jimmy Nelson');
filterData('Baseball/Milwaukee/Jonathan Lucroy');
filterData('Baseball/Milwaukee/Jonathan Villar');
filterData('Baseball/Milwaukee/Matt Garza');
filterData('Baseball/Milwaukee/Ryan Braun');
filterData('Baseball/Milwaukee/Taylor Jungmann');
filterData('Baseball/Minnesota/Brian Dozier');
filterData('Baseball/Minnesota/Byron Buxton');
filterData('Baseball/Minnesota/Byung-Ho Park');
filterData('Baseball/Minnesota/Eddie Rosario');
filterData('Baseball/Minnesota/Eduardo Escobar');
filterData('Baseball/Minnesota/Joe Mauer');
filterData('Baseball/Minnesota/Jose Berrios');
filterData('Baseball/New York/Alex Rodriguez');
filterData('Baseball/New York/Andrew Miller');
filterData('Baseball/New York/Aroldis Chapman');
filterData('Baseball/New York/Bartolo Colon');
filterData('Baseball/New York/Brian McCann');
filterData('Baseball/New York/CC Sabathia');
filterData('Baseball/New York/Carlos Beltran');
filterData('Baseball/New York/Curtis Granderson');
filterData('Baseball/New York/David Wright');
filterData('Baseball/New York/Didi Gregorious');
filterData('Baseball/New York/Jacob deGrom');
filterData('Baseball/New York/Jacoby Ellsbury');
filterData('Baseball/New York/Luis Severino');
filterData('Baseball/New York/Mark Teixiera');
filterData('Baseball/New York/Masahiro Tanaka');
filterData('Baseball/New York/Matt Harvey');
filterData('Baseball/New York/Michael Conforto');
filterData('Baseball/New York/Neil Walker');
filterData('Baseball/New York/Noah Syndergaard');
filterData('Baseball/New York/Starlin Castro');
filterData('Baseball/New York/Steven Matz');
filterData('Baseball/New York/Travis dArnaud');
filterData('Baseball/New York/Yoenis Cespedes');
filterData('Baseball/Oakland/Billy Burns');
filterData('Baseball/Oakland/Billy Butler');
filterData('Baseball/Oakland/Coco Crisp');
filterData('Baseball/Oakland/Khris Davis');
filterData('Baseball/Oakland/Rich Hill');
filterData('Baseball/Oakland/Sonny Gray');
filterData('Baseball/Oakland/Stephen Vogt');
filterData('Baseball/Philadelphia/Aaron Nola');
filterData('Baseball/Philadelphia/Freddy Galvis');
filterData('Baseball/Philadelphia/Maikel Franco');
filterData('Baseball/Philadelphia/Odubel Herrera');
filterData('Baseball/Philadelphia/Peter Bourjos');
filterData('Baseball/Philadelphia/Ryan Howard');
filterData('Baseball/Philadelphia/Vincent Velasquez');
filterData('Baseball/Pittsburgh/Andrew McCutchen');
filterData('Baseball/Pittsburgh/Chris Stewart');
filterData('Baseball/Pittsburgh/Francisco Cervelli');
filterData('Baseball/Pittsburgh/Francisco Liriano');
filterData('Baseball/Pittsburgh/Gerrit Cole');
filterData('Baseball/Pittsburgh/Gerritt Cole');
filterData('Baseball/Pittsburgh/Gregory Polanco');
filterData('Baseball/Pittsburgh/Josh Harrison');
filterData('Baseball/Pittsburgh/Starling Marte Font K');
filterData('Baseball/Pittsburgh/Starling Marte');
filterData('Baseball/San Diego/Alexei Ramirez');
filterData('Baseball/San Diego/Andrew Cashner');
filterData('Baseball/San Diego/Matt Kemp');
filterData('Baseball/San Diego/Tyson Ross');
filterData('Baseball/San Diego/Wil Myers');
filterData('Baseball/San Francisco/Brandon Crawford');
filterData('Baseball/San Francisco/Buster Posey');
filterData('Baseball/San Francisco/Denard Span');
filterData('Baseball/San Francisco/George Kontos');
filterData('Baseball/San Francisco/Hunter Pence');
filterData('Baseball/San Francisco/Jeff Samardzija');
filterData('Baseball/San Francisco/Johnny Cueto');
filterData('Baseball/San Francisco/Madison Bumgarner');
filterData('Baseball/Seattle/Adam Lind');
filterData('Baseball/Seattle/Felix Hernandez');
filterData('Baseball/Seattle/Hisashi Iwakuma');
filterData('Baseball/Seattle/Kyle Seager');
filterData('Baseball/Seattle/Nelson Cruz');
filterData('Baseball/Seattle/Nori Aoki');
filterData('Baseball/Seattle/Robinson Cano');
filterData('Baseball/Seattle/Taijuan Walker');
filterData('Baseball/St. Louis/Adam Wainwright');
filterData('Baseball/St. Louis/Aledmys Diaz');
filterData('Baseball/St. Louis/Jhonny Peralta');
filterData('Baseball/St. Louis/Kolten Wong');
filterData('Baseball/St. Louis/Matt Carpenter');
filterData('Baseball/St. Louis/Matt Holliday');
filterData('Baseball/St. Louis/Michael Wacha');
filterData('Baseball/St. Louis/Stephen Piscotty');
filterData('Baseball/St. Louis/Yadier Molina');
filterData('Baseball/Tampa Bay/Chris Archer');
filterData('Baseball/Tampa Bay/Desmond Jennings');
filterData('Baseball/Tampa Bay/Drew Smyly');
filterData('Baseball/Tampa Bay/Evan Longoria');
filterData('Baseball/Tampa Bay/Jake Odorizzi');
filterData('Baseball/Tampa Bay/Kevin Kiermaier');
filterData('Baseball/Tampa Bay/Logan Forsythe');
filterData('Baseball/Tampa Bay/Matt Moore');
filterData('Baseball/Tampa Bay/Steven Souza Jr');
filterData('Baseball/Texas/Adrian Beltre');
filterData('Baseball/Texas/Cole Hamels');
filterData('Baseball/Texas/Elvis Andrus');
filterData('Baseball/Texas/Ian Desmond');
filterData('Baseball/Texas/Nomar Mazara');
filterData('Baseball/Texas/Prince Fielder');
filterData('Baseball/Texas/Yu Darvish');
filterData('Baseball/Toronto/Edwin Encarnacion');
filterData('Baseball/Toronto/Jose Bautista');
filterData('Baseball/Toronto/Josh Donaldson');
filterData('Baseball/Toronto/Marco Estrada');
filterData('Baseball/Toronto/Marcus Stroman');
filterData('Baseball/Toronto/RA Dickey');
filterData('Baseball/Toronto/Russell Martin');
filterData('Baseball/Toronto/Troy Tulowitzki');
filterData('Baseball/Washington DC/Anthony Rendon');
filterData('Baseball/Washington DC/Bryce Harper');
filterData('Baseball/Washington DC/Daniel Murphy');
filterData('Baseball/Washington DC/Gio Gonzalez');
filterData('Baseball/Washington DC/Jayson Werth');
filterData('Baseball/Washington DC/Max Scherzer');
filterData('Baseball/Washington DC/Ryan Zimmerman');
filterData('Baseball/Washington DC/Stephen Strasburg');
filterData('Baseball/Washington DC/Trea Turner');
filterData('Baseball/Washington DC/Wilson Ramos');
filterData('Basketball/Los Angeles/Ryan Kelly');
filterData('Basketball/Memphis/Vince Carter');
filterData('Basketball/New York/Courtney Lee');
filterData('Basketball/Utah/Shelvin Mack');
filterData('Charity/Charity/Waterboys');
filterData('Fantasy Life/Fantasy Life/Fantasy Football');
filterData('Fantasy Life/Fantasy Life/Field Yates');
filterData('Fantasy Life/Fantasy Life/Matthew Berry');
filterData('Football/Arizona/Andre Ellington');
filterData('Football/Arizona/Brittan Golden');
filterData('Football/Arizona/Calais Campbell');
filterData('Football/Arizona/Carson Palmer Larry Fitzgerald');
filterData('Football/Arizona/Carson Palmer Michael Floyd');
filterData('Football/Arizona/Carson Palmer');
filterData('Football/Arizona/Chandler Catanzaro');
filterData('Football/Arizona/DJ Humphries');
filterData('Football/Arizona/Deone Bucannon');
filterData('Football/Arizona/Drew Stanton');
filterData('Football/Arizona/Frostee Rucker');
filterData('Football/Arizona/Jaron Brown');
filterData('Football/Arizona/John Brown');
filterData('Football/Arizona/Larry Fitzgerald');
filterData('Football/Arizona/Michael Floyd');
filterData('Football/Arizona/Patrick Peterson and Tyrann Mathieu');
filterData('Football/Arizona/Patrick Peterson');
filterData('Football/Arizona/Robert Nkemdiche');
filterData('Football/Arizona/Rodney Gunter');
filterData('Football/Arizona/Sean Weatherspoon');
filterData('Football/Arizona/Tyrann Mathieu');
filterData('Football/Atlanta/Desmond Trufant');
filterData('Football/Atlanta/Devin Hester');
filterData('Football/Atlanta/Devonta Freeman');
filterData('Football/Atlanta/Julio Jones');
filterData('Football/Atlanta/Keanu Neal');
filterData('Football/Atlanta/Kemal Ishmael');
filterData('Football/Atlanta/Matt Bryant');
filterData('Football/Atlanta/Matt Ryan Julio Jones');
filterData('Football/Atlanta/Matt Ryan');
filterData('Football/Atlanta/Patrick DiMarco');
filterData('Football/Atlanta/Tevin Coleman');
filterData('Football/Atlanta/Victor Beasley');
filterData('Football/Baltimore/Breshad Perriman');
filterData('Football/Baltimore/Bryn Renner');
filterData('Football/Baltimore/CJ Mosley');
filterData('Football/Baltimore/Chris Moore');
filterData('Football/Baltimore/Crockett Gillmore');
filterData('Football/Baltimore/Elvis Dumervil');
filterData('Football/Baltimore/Joe Flacco');
filterData('Football/Baltimore/Justin Forsett');
filterData('Football/Baltimore/Justin Tucker');
filterData('Football/Baltimore/Keenan Reynolds');
filterData('Football/Baltimore/Kenneth Dixon');
filterData('Football/Baltimore/Marshal Yanda');
filterData('Football/Baltimore/Mike Wallace');
filterData('Football/Baltimore/Ronnie Staley');
filterData('Football/Baltimore/Ronnie Stanley');
filterData('Football/Baltimore/Steve Smith Sr');
filterData('Football/Baltimore/Tavon Young');
filterData('Football/Baltimore/Terrell Suggs');
filterData('Football/Buffalo/Aaron Williams');
filterData('Football/Buffalo/Cardale Jones');
filterData('Football/Buffalo/Charles Clay');
filterData('Football/Buffalo/Dan Carpenter');
filterData('Football/Buffalo/EJ Manuel');
filterData('Football/Buffalo/Jerry Hughes');
filterData('Football/Buffalo/Jonathan Williams');
filterData('Football/Buffalo/LeSean McCoy');
filterData('Football/Buffalo/Marcell Dareus');
filterData('Football/Buffalo/Mario Williams');
filterData('Football/Buffalo/Ronald Darby');
filterData('Football/Buffalo/Sammy Watkins');
filterData('Football/Buffalo/Stephon Gilmore');
filterData('Football/Buffalo/TJ Barnes');
filterData('Football/Buffalo/Tyrod Taylor');
filterData('Football/Carolina/Ben Jacobs');
filterData('Football/Carolina/Brian Folkerts');
filterData('Football/Carolina/Cam Newton Greg Olsen');
filterData('Football/Carolina/Cam Newton');
filterData('Football/Carolina/Devin Funchess');
filterData('Football/Carolina/Ed Dickson');
filterData('Football/Carolina/Greg Olsen');
filterData('Football/Carolina/Jonathan Stewart');
filterData('Football/Carolina/Josh Norman');
filterData('Football/Carolina/Kelvin Benjamin');
filterData('Football/Carolina/Kony Ealy');
filterData('Football/Carolina/Kurt Coleman');
filterData('Football/Carolina/Luke Kuechly');
filterData('Football/Carolina/Mike Remmers');
filterData('Football/Carolina/Mike Tolbert');
filterData('Football/Carolina/Roman Harper');
filterData('Football/Carolina/Shaq Thompson');
filterData('Football/Carolina/Star Lotulelei');
filterData('Football/Carolina/Ted Ginn Jr');
filterData('Football/Carolina/Teddy Williams');
filterData('Football/Carolina/Thomas Davis');
filterData('Football/Chicago/Alshon Jeffery');
filterData('Football/Chicago/Antrel Rolle');
filterData('Football/Chicago/Brian Urlacher');
filterData('Football/Chicago/Daniel Braverman');
filterData('Football/Chicago/Jared Allen');
filterData('Football/Chicago/Jay Cutler Alshon Jeffery');
filterData('Football/Chicago/Jay Cutler Eddie Royal');
filterData('Football/Chicago/Jay Cutler');
filterData('Football/Chicago/Jeremiah Ratliff');
filterData('Football/Chicago/Jeremy Langford');
filterData('Football/Chicago/Jimmy Clausen');
filterData('Football/Chicago/Jordan Howard');
filterData('Football/Chicago/Kevin White');
filterData('Football/Chicago/Kyle Fuller');
filterData('Football/Chicago/Kyle Long');
filterData('Football/Chicago/Leonard Floyd');
filterData('Football/Chicago/Marquess Wilson');
filterData('Football/Chicago/Pat ODonnell');
filterData('Football/Chicago/Robbie Gould');
filterData('Football/Chicago/Sherrick McManis');
filterData('Football/Chicago/Taveze Calhoun');
filterData('Football/Chicago/Thomas Gafford');
filterData('Football/Chicago/Tim Jennings');
filterData('Football/Chicago/Zach Miller');
filterData('Football/Cincinnati/AJ Green');
filterData('Football/Cincinnati/AJ Hawk');
filterData('Football/Cincinnati/Adam Jones');
filterData('Football/Cincinnati/Andrew Whitworth');
filterData('Football/Cincinnati/Andy Dalton AJ Green');
filterData('Football/Cincinnati/Andy Dalton');
filterData('Football/Cincinnati/Carlos Dunlap');
filterData('Football/Cincinnati/Clint Boling');
filterData('Football/Cincinnati/Domata Peko');
filterData('Football/Cincinnati/Dre Kirkpatrick');
filterData('Football/Cincinnati/Eric Winston');
filterData('Football/Cincinnati/Geno Atkins');
filterData('Football/Cincinnati/Giovani Bernard');
filterData('Football/Cincinnati/Jeremy Hill');
filterData('Football/Cincinnati/Kevin Huber');
filterData('Football/Cincinnati/Marquis Flowers');
filterData('Football/Cincinnati/Mohamed Sanu');
filterData('Football/Cincinnati/Pacman Jones');
filterData('Football/Cincinnati/Rey Maualuga');
filterData('Football/Cincinnati/Sean Porter');
filterData('Football/Cincinnati/Tyler Boyd');
filterData('Football/Cincinnati/Tyler Eifert');
filterData('Football/Cincinnati/Vontaze Burfict');
filterData('Football/Cleveland/Brian Hartline');
filterData('Football/Cleveland/Cody Kessler');
filterData('Football/Cleveland/Connor Shaw');
filterData('Football/Cleveland/Corey Coleman');
filterData('Football/Cleveland/Danny Shelton');
filterData('Football/Cleveland/Donte Whitner');
filterData('Football/Cleveland/Dwayne Bowe');
filterData('Football/Cleveland/Gary Barnidge');
filterData('Football/Cleveland/Isaiah Crowell');
filterData('Football/Cleveland/Joe Haden');
filterData('Football/Cleveland/Johnny Manziel');
filterData('Football/Cleveland/Josh Gordon');
filterData('Football/Cleveland/Josh McCown');
filterData('Football/Cleveland/Justin Gilbert');
filterData('Football/Cleveland/Nile Lawerence-Stample');
filterData('Football/Cleveland/Raheem Mostert');
filterData('Football/Cleveland/Ricardo Louis');
filterData('Football/Cleveland/Taylor Gabriel');
filterData('Football/Cleveland/Travis Benjamin');
filterData('Football/Dallas/Barry Church');
filterData('Football/Dallas/Byron Jones');
filterData('Football/Dallas/Chaz Green');
filterData('Football/Dallas/Cole Beasley');
filterData('Football/Dallas/Dak Prescott');
filterData('Football/Dallas/Damien Wilson');
filterData('Football/Dallas/Dan Bailey');
filterData('Football/Dallas/Darren McFadden');
filterData('Football/Dallas/Deon King');
filterData('Football/Dallas/Dez Bryant');
filterData('Football/Dallas/Ezekiel Elliott');
filterData('Football/Dallas/Greg Hardy');
filterData('Football/Dallas/Jason Witten');
filterData('Football/Dallas/Joseph Randle');
filterData('Football/Dallas/Nick Hayden');
filterData('Football/Dallas/Randy Gregory');
filterData('Football/Dallas/Rolando McClain');
filterData('Football/Dallas/Ryan Miller');
filterData('Football/Dallas/Sean Lee');
filterData('Football/Dallas/Terrance Williams');
filterData('Football/Dallas/Tony Romo Darren McFadden');
filterData('Football/Dallas/Tony Romo Dez Bryant');
filterData('Football/Dallas/Tony Romo Jason Witten');
filterData('Football/Dallas/Tony Romo Terrance Williams');
filterData('Football/Dallas/Tony Romo');
filterData('Football/Dallas/Travis Frederick');
filterData('Football/Dallas/Tyron Smith');
filterData('Football/Denver/Aqib Talib');
filterData('Football/Denver/Brandon McManus');
filterData('Football/Denver/Brock Osweiler');
filterData('Football/Denver/CJ Anderson');
filterData('Football/Denver/Chase Vaughn');
filterData('Football/Denver/Chris Harris Jr');
filterData('Football/Denver/Chris Harris');
filterData('Football/Denver/DeMarcus Ware Von Miller');
filterData('Football/Denver/DeMarcus Ware');
filterData('Football/Denver/Demarcus Ware');
filterData('Football/Denver/Demaryius Thomas');
filterData('Football/Denver/Devontae Booker');
filterData('Football/Denver/Emmanuel Sanders');
filterData('Football/Denver/Jeremy Stewart');
filterData('Football/Denver/Kayvon Webster');
filterData('Football/Denver/Kyle Williams');
filterData('Football/Denver/Montee Ball');
filterData('Football/Denver/Owen Daniels');
filterData('Football/Denver/Paxton Lynch');
filterData('Football/Denver/Peyton Manning Emmanuel Sanders');
filterData('Football/Denver/Peyton Manning');
filterData('Football/Denver/Ryan Clady');
filterData('Football/Denver/Shane Ray');
filterData('Football/Denver/Shelley Smith');
filterData('Football/Denver/Steven Johnson');
filterData('Football/Denver/TJ Ward');
filterData('Football/Denver/Terrell Davis');
filterData('Football/Denver/Von Miller');
filterData('Football/Detroit/Ameer Abdullah');
filterData('Football/Detroit/Brandon Pettigrew');
filterData('Football/Detroit/Calvin Johnson');
filterData('Football/Detroit/Dan Orlovsky');
filterData('Football/Detroit/Darius Slay');
filterData('Football/Detroit/Don Carey');
filterData('Football/Detroit/Glover Quin');
filterData('Football/Detroit/Golden Tate');
filterData('Football/Detroit/Haloti Ngata');
filterData('Football/Detroit/Jay Lee');
filterData('Football/Detroit/Laken Tomlinson');
filterData('Football/Detroit/Matt Prater');
filterData('Football/Detroit/Matt Stafford Calvin Johnson');
filterData('Football/Detroit/Matt Stafford Golden Tate');
filterData('Football/Detroit/Matt Stafford');
filterData('Football/Detroit/Matthew Stafford');
filterData('Football/Detroit/Stephen Tulloch');
filterData('Football/Detroit/Taylor Decker');
filterData('Football/Detroit/Theo Riddick');
filterData('Football/Green Bay/Aaron Rodgers');
filterData('Football/Green Bay/BJ Raji');
filterData('Football/Green Bay/Clay Matthews');
filterData('Football/Green Bay/Davante Adams');
filterData('Football/Green Bay/DeVante Parker');
filterData('Football/Green Bay/Eddie Lacy');
filterData('Football/Green Bay/James Jones');
filterData('Football/Green Bay/Joe Thomas');
filterData('Football/Green Bay/John Crockett');
filterData('Football/Green Bay/John Kuhn');
filterData('Football/Green Bay/Jordy Nelson');
filterData('Football/Green Bay/Julius Peppers');
filterData('Football/Green Bay/Mason Crosby');
filterData('Football/Green Bay/Morgan Burnett');
filterData('Football/Green Bay/Randall Cobb');
filterData('Football/Green Bay/Richard Rodgers');
filterData('Football/Green Bay/Trevor Davis');
filterData('Football/Houston/Arian Foster');
filterData('Football/Houston/Braxton Miller');
filterData('Football/Houston/Brian Cushing');
filterData('Football/Houston/Brian Hoyer');
filterData('Football/Houston/Cecil Shorts III');
filterData('Football/Houston/DeAndre Hopkins');
filterData('Football/Houston/JJ Watt Brian Cushing');
filterData('Football/Houston/JJ Watt');
filterData('Football/Houston/Jadeveon Clowney');
filterData('Football/Houston/Jaelen Strong');
filterData('Football/Houston/Jeoffrey Pagan');
filterData('Football/Houston/Kareem Jackson');
filterData('Football/Houston/Kevin Johnson');
filterData('Football/Houston/Shane Lechler');
filterData('Football/Houston/Tyler Ervin');
filterData('Football/Houston/Vince Wilfork');
filterData('Football/Houston/Will Fuller');
filterData('Football/Indianapolis/Adam Vinatieri');
filterData('Football/Indianapolis/Andre Johnson');
filterData('Football/Indianapolis/Andrew Luck Andre Johnson');
filterData('Football/Indianapolis/Andrew Luck');
filterData('Football/Indianapolis/Cam Johnson');
filterData('Football/Indianapolis/Coby Fleener');
filterData('Football/Indianapolis/DQwell Jackson');
filterData('Football/Indianapolis/Frank Gore Andre Johnson');
filterData('Football/Indianapolis/Frank Gore');
filterData('Football/Indianapolis/Jerrell Freeman');
filterData('Football/Indianapolis/Kendall Langford');
filterData('Football/Indianapolis/Pat McAfee');
filterData('Football/Indianapolis/Quan Bray');
filterData('Football/Indianapolis/Robert Mathis');
filterData('Football/Indianapolis/TJ Green');
filterData('Football/Indianapolis/TY Hilton Andre Johnson');
filterData('Football/Indianapolis/TY Hilton');
filterData('Football/Indianapolis/The Ghost');
filterData('Football/Indianapolis/Vontae Davis');
filterData('Football/Jacksonville/Allen Hurns');
filterData('Football/Jacksonville/Allen Robinson');
filterData('Football/Jacksonville/Blake Bortles Allen Hurns');
filterData('Football/Jacksonville/Blake Bortles');
filterData('Football/Jacksonville/Dante Fowler');
filterData('Football/Jacksonville/Jalen Ramsey');
filterData('Football/Jacksonville/Julius Thomas');
filterData('Football/Jacksonville/Justin Blackmon');
filterData('Football/Jacksonville/Kasey Redfern');
filterData('Football/Jacksonville/Luke Joeckel');
filterData('Football/Jacksonville/Marqise Lee');
filterData('Football/Jacksonville/Nick Marshall');
filterData('Football/Jacksonville/Paul Posluszny');
filterData('Football/Jacksonville/SenDerrick Marks');
filterData('Football/Jacksonville/TJ Yeldon');
filterData('Football/Jacksonville/Telvin Smith');
filterData('Football/Jacksonville/Toby Gerhart');
filterData('Football/Jacksonville/Tony Washington');
filterData('Football/Jacksonville/Yannick Ngakoue');
filterData('Football/Kansas City/Alex Smith Jamaal Charles');
filterData('Football/Kansas City/Alex Smith Jeremy Maclin');
filterData('Football/Kansas City/Alex Smith');
filterData('Football/Kansas City/Charcandrick West');
filterData('Football/Kansas City/DeAnthony Thomas');
filterData('Football/Kansas City/DeMarcus Robinson');
filterData('Football/Kansas City/Derrick Johnson');
filterData('Football/Kansas City/Eric Berry');
filterData('Football/Kansas City/Eric Murray');
filterData('Football/Kansas City/Jamaal Charles');
filterData('Football/Kansas City/Jeremy Maclin');
filterData('Football/Kansas City/Justin Houston Tamba Hali');
filterData('Football/Kansas City/Justin Houston');
filterData('Football/Kansas City/Kevin Hogan');
filterData('Football/Kansas City/Marcus Peters');
filterData('Football/Kansas City/Tamba Hali');
filterData('Football/Kansas City/Travis Kelce');
filterData('Football/Los Angeles/Aaron Donald');
filterData('Football/Los Angeles/Alec Ogletree');
filterData('Football/Los Angeles/Brandon McGee');
filterData('Football/Los Angeles/Chris Long');
filterData('Football/Los Angeles/Duke Williams');
filterData('Football/Los Angeles/Jared Cook');
filterData('Football/Los Angeles/Jared Goff');
filterData('Football/Los Angeles/Johnny Hekker');
filterData('Football/Los Angeles/Kenny Britt');
filterData('Football/Los Angeles/Michael Brockers');
filterData('Football/Los Angeles/Nick Foles Brian Quick');
filterData('Football/Los Angeles/Nick Foles');
filterData('Football/Los Angeles/Pharoh Cooper');
filterData('Football/Los Angeles/Robert Quinn');
filterData('Football/Los Angeles/Rodger Saffold');
filterData('Football/Los Angeles/Tavon Austin');
filterData('Football/Los Angeles/Todd Gurley');
filterData('Football/Los Angeles/Wes Welker');
filterData('Football/Los Angeles/William Hayes');
filterData('Football/Miami/Cameron Wake');
filterData('Football/Miami/Dion Sims');
filterData('Football/Miami/James Burgess Jr');
filterData('Football/Miami/Jarvis Landry');
filterData('Football/Miami/Jermon Bushrod');
filterData('Football/Miami/Jordan Cameron');
filterData('Football/Miami/Kenyan Drake');
filterData('Football/Miami/Knowshon Moreno');
filterData('Football/Miami/Koa Misi');
filterData('Football/Miami/Lamar Miller');
filterData('Football/Miami/Laramy Tunsil');
filterData('Football/Miami/Leontee Carroo');
filterData('Football/Miami/Michael Thomas');
filterData('Football/Miami/Ndamukong Suh');
filterData('Football/Miami/Ryan Tannehill Rishard Matthews');
filterData('Football/Miami/Ryan Tannehill');
filterData('Football/Minnesota/Adam Thielen');
filterData('Football/Minnesota/Adrian Peterson');
filterData('Football/Minnesota/Anthony Barr');
filterData('Football/Minnesota/Charles Johnson');
filterData('Football/Minnesota/Cordarrelle Patterson');
filterData('Football/Minnesota/Kyle Rudolph');
filterData('Football/Minnesota/Laquon Treadwell');
filterData('Football/Minnesota/Mackensie Alexander');
filterData('Football/Minnesota/Matt Asiata');
filterData('Football/Minnesota/Moritz Bohringer');
filterData('Football/Minnesota/Stefon Diggs');
filterData('Football/Minnesota/Stephon Diggs');
filterData('Football/Minnesota/Teddy Bridgewater & Cordarrelle Patterson');
filterData('Football/Minnesota/Teddy Bridgewater Adrian Peterson');
filterData('Football/Minnesota/Teddy Bridgewater');
filterData('Football/Minnesota/Trae Waynes');
filterData('Football/Minnesota/Zach Line');
filterData('Football/New England/Danny Amendola');
filterData('Football/New England/Darrelle Revis');
filterData('Football/New England/Dion Lewis');
filterData('Football/New England/James White');
filterData('Football/New England/Jerod Mayo');
filterData('Football/New England/Jimmy Garoppolo');
filterData('Football/New England/Julian Edelman');
filterData('Football/New England/Malcolm Butler');
filterData('Football/New England/Malcolm Mitchell');
filterData('Football/New England/Martellus Bennett');
filterData('Football/New England/Patrick Chung');
filterData('Football/New England/Rob Gronkowski');
filterData('Football/New England/Rob Ninkovich');
filterData('Football/New England/Scott Chandler');
filterData('Football/New England/Stephen Gostkowski');
filterData('Football/New England/Tom Brady Rob Gronkowski');
filterData('Football/New England/Tom Brady');
filterData('Football/New England/Tom Newton Rob Best Olsen');
filterData('Football/New Orleans/Andrus Peat');
filterData('Football/New Orleans/Benjamin Watson');
filterData('Football/New Orleans/Brandin Cooks');
filterData('Football/New Orleans/Brandon Browner');
filterData('Football/New Orleans/CJ Spiller');
filterData('Football/New Orleans/Dannell Ellerbe');
filterData('Football/New Orleans/Delvin Breaux');
filterData('Football/New Orleans/Drew Brees');
filterData('Football/New Orleans/Jahri Evans');
filterData('Football/New Orleans/Jairus Byrd');
filterData('Football/New Orleans/Joe Morgan');
filterData('Football/New Orleans/Jordan Williams-Lambert');
filterData('Football/New Orleans/Kyle Wilson');
filterData('Football/New Orleans/Mark Ingram');
filterData('Football/New Orleans/Marques Colston');
filterData('Football/New Orleans/Sheldon Rankins');
filterData('Football/New Orleans/Vinnie Sunseri');
filterData('Football/New York/Antonio Cromartie');
filterData('Football/New York/Brandon Marshall');
filterData('Football/New York/Chris Ivory');
filterData('Football/New York/Christian Hackenberg');
filterData('Football/New York/Darron Lee');
filterData('Football/New York/Devin Smith');
filterData('Football/New York/Dominique Rodgers Cromartie');
filterData('Football/New York/Dominique Rodgers-Cromartie');
filterData('Football/New York/Eli Apple');
filterData('Football/New York/Eli Manning Odell Beckham Jr');
filterData('Football/New York/Eli Manning');
filterData('Football/New York/Ereck Flowers');
filterData('Football/New York/Eric Decker');
filterData('Football/New York/Geno Smith');
filterData('Football/New York/Jaiquawn Jarrett');
filterData('Football/New York/Jason Pierre-Paul');
filterData('Football/New York/Josh Brown');
filterData('Football/New York/Larry Donnell');
filterData('Football/New York/Leonard Williams');
filterData('Football/New York/Marcus Williams');
filterData('Football/New York/Marshall Newhouse');
filterData('Football/New York/Matt Forte');
filterData('Football/New York/Muhammad Wilkerson');
filterData('Football/New York/Nick Folk');
filterData('Football/New York/Nick Mangold');
filterData('Football/New York/Odell Beckham Jr');
filterData('Football/New York/Paul Perkins');
filterData('Football/New York/Rashad Jennings');
filterData('Football/New York/Ryan Fitzpatrick');
filterData('Football/New York/Sheldon Richardson');
filterData('Football/New York/Sterling Shepard');
filterData('Football/New York/Victor Cruz');
filterData('Football/New York/Zac Stacy');
filterData('Football/Oakland/Amari Cooper');
filterData('Football/Oakland/Charles Woodson');
filterData('Football/Oakland/Connor Cook');
filterData('Football/Oakland/Dan Williams');
filterData('Football/Oakland/DeAndre Washington');
filterData('Football/Oakland/Derek Carr Amari Cooper');
filterData('Football/Oakland/Derek Carr');
filterData('Football/Oakland/Justin Tuck');
filterData('Football/Oakland/Karl Joseph');
filterData('Football/Oakland/Khalil Mack');
filterData('Football/Oakland/Latavius Murray');
filterData('Football/Oakland/Malcolm Smith');
filterData('Football/Oakland/Marquette King');
filterData('Football/Oakland/Michael Crabtree');
filterData('Football/Oakland/Neiron Ball');
filterData('Football/Oakland/Sebastian Janikowski');
filterData('Football/Philadelphia/Bennie Logan');
filterData('Football/Philadelphia/Brent Celek');
filterData('Football/Philadelphia/Carson Wentz');
filterData('Football/Philadelphia/Cody Parkey');
filterData('Football/Philadelphia/Connor Barwin');
filterData('Football/Philadelphia/Darrell Greene');
filterData('Football/Philadelphia/Darren Sproles');
filterData('Football/Philadelphia/DeMarco Murray');
filterData('Football/Philadelphia/Jason Peters');
filterData('Football/Philadelphia/Jordan Hicks');
filterData('Football/Philadelphia/Kiko Alonso');
filterData('Football/Philadelphia/Lane Johnson');
filterData('Football/Philadelphia/Miles Austin');
filterData('Football/Philadelphia/Nelson Agholor');
filterData('Football/Philadelphia/Riley Cooper');
filterData('Football/Philadelphia/Ryan Mathews');
filterData('Football/Philadelphia/Sam Bradford Darren Sproles');
filterData('Football/Philadelphia/Sam Bradford Ryan Matthews');
filterData('Football/Philadelphia/Sam Bradford Zach Ertz');
filterData('Football/Philadelphia/Sam Bradford');
filterData('Football/Philadelphia/Tim Tebow');
filterData('Football/Philadelphia/Wendall Smallwood');
filterData('Football/Philadelphia/Wendell Smallwood');
filterData('Football/Philadelphia/Zach Ertz Play');
filterData('Football/Philadelphia/Zach Ertz');
filterData('Football/Pittsburgh/Alvin Dupree');
filterData('Football/Pittsburgh/Antonio Brown');
filterData('Football/Pittsburgh/Ben Roethlisberger Antonio Brown');
filterData('Football/Pittsburgh/Ben Roethlisberger');
filterData('Football/Pittsburgh/Bud Dupree');
filterData('Football/Pittsburgh/DeAngelo Williams');
filterData('Football/Pittsburgh/Heath Miller');
filterData('Football/Pittsburgh/James Harrison');
filterData('Football/Pittsburgh/LeVeon Bell');
filterData('Football/Pittsburgh/Markus Wheaton');
filterData('Football/Pittsburgh/Martavis Bryant');
filterData('Football/Pittsburgh/Matt Murray');
filterData('Football/Pittsburgh/Mike Vick');
filterData('Football/San Diego/Antonio Gates');
filterData('Football/San Diego/Chris Davis');
filterData('Football/San Diego/Danny Woodhead');
filterData('Football/San Diego/Darrell Stuckey');
filterData('Football/San Diego/David Johnson');
filterData('Football/San Diego/Eric Weddle');
filterData('Football/San Diego/Hunter Henry');
filterData('Football/San Diego/Jacoby Jones');
filterData('Football/San Diego/Jason Verrett');
filterData('Football/San Diego/Joey Bosa');
filterData('Football/San Diego/Josh Lambo');
filterData('Football/San Diego/Keenan Allen');
filterData('Football/San Diego/Kenny Wiggins');
filterData('Football/San Diego/Kyle Emanuel');
filterData('Football/San Diego/Manti Teo');
filterData('Football/San Diego/Melvin Gordon');
filterData('Football/San Diego/Mike Scifres');
filterData('Football/San Diego/Mike Windt');
filterData('Football/San Diego/Nick Dzubnar');
filterData('Football/San Diego/Philip Rivers Antonio Gates');
filterData('Football/San Diego/Philip Rivers Keenan Allen');
filterData('Football/San Diego/Philip Rivers Malcom Floyd');
filterData('Football/San Diego/Philip Rivers');
filterData('Football/San Diego/Sean Lissemore');
filterData('Football/San Diego/Sean McGrath');
filterData('Football/San Diego/Tourek Williams');
filterData('Football/San Francisco/Aldon Smith');
filterData('Football/San Francisco/Andy Lee');
filterData('Football/San Francisco/Anquan Boldin');
filterData('Football/San Francisco/Antoine Bethea');
filterData('Football/San Francisco/Asante Cleveland');
filterData('Football/San Francisco/Bruce Ellington');
filterData('Football/San Francisco/Bruce Miller');
filterData('Football/San Francisco/Carlos Hyde');
filterData('Football/San Francisco/Colin Kaepernick Anquan Boldin');
filterData('Football/San Francisco/Colin Kaepernick');
filterData('Football/San Francisco/DeForest Buckner');
filterData('Football/San Francisco/Derek Carrier');
filterData('Football/San Francisco/Garrett Celek');
filterData('Football/San Francisco/Jarryd Hayne');
filterData('Football/San Francisco/Justin Smith');
filterData('Football/San Francisco/Kendall Hunter');
filterData('Football/San Francisco/Marcus Cromartie');
filterData('Football/San Francisco/Mike Davis');
filterData('Football/San Francisco/NaVorro Bowman');
filterData('Football/San Francisco/Reggie Bush');
filterData('Football/San Francisco/Vance McDonald');
filterData('Football/San Francisco/Vernon Davis');
filterData('Football/Seattle/AJ Prosise');
filterData('Football/Seattle/Alex Collins');
filterData('Football/Seattle/Bobby Wagner');
filterData('Football/Seattle/Brandon Mebane');
filterData('Football/Seattle/Brock Coyle');
filterData('Football/Seattle/Bruce Irvin');
filterData('Football/Seattle/CJ Prosise');
filterData('Football/Seattle/Cliff Avril');
filterData('Football/Seattle/Clint Gresham');
filterData('Football/Seattle/DeShawn Shead');
filterData('Football/Seattle/Doug Baldwin');
filterData('Football/Seattle/Earl Thomas');
filterData('Football/Seattle/George Fant');
filterData('Football/Seattle/JR Sweezy');
filterData('Football/Seattle/Jeremy Lane');
filterData('Football/Seattle/Jermaine Kearse');
filterData('Football/Seattle/Jimmy Graham');
filterData('Football/Seattle/Jon Ryan');
filterData('Football/Seattle/KJ Wright');
filterData('Football/Seattle/Kam Chancellor');
filterData('Football/Seattle/Luke Willson');
filterData('Football/Seattle/Marshawn Lynch');
filterData('Football/Seattle/Michael Bennett');
filterData('Football/Seattle/Richard Sherman Kam Chancellor');
filterData('Football/Seattle/Richard Sherman');
filterData('Football/Seattle/Russell Wilson');
filterData('Football/Seattle/Seattle Skyline');
filterData('Football/Seattle/Steven Hauschka');
filterData('Football/Seattle/Thomas Rawls');
filterData('Football/Seattle/Tyler Lockett');
filterData('Football/Seattle/Wilson Newton Lynch Best Olsen');
filterData('Football/Seattle/Wilson Newton Lynch Olsen');
filterData('Football/Tampa Bay/CJ Wilson');
filterData('Football/Tampa Bay/Chris Hackett');
filterData('Football/Tampa Bay/Doug Martin');
filterData('Football/Tampa Bay/Gerald McCoy');
filterData('Football/Tampa Bay/Jameis Winston Mike Evans');
filterData('Football/Tampa Bay/Jameis Winston Vincent Jackson');
filterData('Football/Tampa Bay/Jameis Winston');
filterData('Football/Tampa Bay/Keith Tandy');
filterData('Football/Tampa Bay/Kwon Alexander');
filterData('Football/Tampa Bay/Lavonte David');
filterData('Football/Tampa Bay/Louis Murphy');
filterData('Football/Tampa Bay/Mike Evans');
filterData('Football/Tampa Bay/Vernon Hargreaves III');
filterData('Football/Tampa Bay/Vincent Jackson');
filterData('Football/Tennessee/Bishop Sankey');
filterData('Football/Tennessee/Brian Orakpo');
filterData('Football/Tennessee/DaNorris Searcy');
filterData('Football/Tennessee/David Cobb');
filterData('Football/Tennessee/Delanie Walker');
filterData('Football/Tennessee/Derrick Henry');
filterData('Football/Tennessee/Dexter McCluster');
filterData('Football/Tennessee/Jack Conklin');
filterData('Football/Tennessee/Kendall Wright');
filterData('Football/Tennessee/Marcus Mariota');
filterData('Football/Washington DC/Alfred Morris');
filterData('Football/Washington DC/Brandon Scherff');
filterData('Football/Washington DC/Chris Thompson');
filterData('Football/Washington DC/Corey Crawford');
filterData('Football/Washington DC/Darrel Young');
filterData('Football/Washington DC/David Amerson');
filterData('Football/Washington DC/DeAngelo Hall');
filterData('Football/Washington DC/DeSean Jackson');
filterData('Football/Washington DC/Deshazor Everett');
filterData('Football/Washington DC/Josh Doctson');
filterData('Football/Washington DC/Kirk Cousins');
filterData('Football/Washington DC/Matt Jones');
filterData('Football/Washington DC/Morgan Moses');
filterData('Football/Washington DC/Niles Paul');
filterData('Football/Washington DC/Pierre Garcon Font');
filterData('Football/Washington DC/Pierre Garcon');
filterData('Football/Washington DC/Pierre Garson');
filterData('Football/Washington DC/Robert Griffin III');
filterData('Football/Washington DC/Ryan Kerrigan');
filterData('Football/Washington DC/Sua Cravens');
filterData('Football/Washington DC/Trent Williams');
filterData('Hockey/Anaheim/Andrew Cogliano');
filterData('Hockey/Anaheim/Cam Fowler');
filterData('Hockey/Anaheim/Chris Wagner');
filterData('Hockey/Anaheim/Clayton Stoner');
filterData('Hockey/Anaheim/Corey Perry');
filterData('Hockey/Anaheim/Dany Heatley');
filterData('Hockey/Anaheim/Francois Beauchemin');
filterData('Hockey/Anaheim/Frederik Andersen');
filterData('Hockey/Anaheim/Hampus Lindholm');
filterData('Hockey/Anaheim/Jakob Silfverberg');
filterData('Hockey/Anaheim/John Gibson');
filterData('Hockey/Anaheim/Jonas Hiller');
filterData('Hockey/Anaheim/Josh Manson');
filterData('Hockey/Anaheim/Matt Beleskey');
filterData('Hockey/Anaheim/Michael Santorelli');
filterData('Hockey/Anaheim/Nate Thompson');
filterData('Hockey/Anaheim/Patrick Maroon');
filterData('Hockey/Anaheim/Rickard Rakell');
filterData('Hockey/Anaheim/Ryan Getzlaf Ryan Kesler');
filterData('Hockey/Anaheim/Ryan Getzlaf');
filterData('Hockey/Anaheim/Ryan Kesler');
filterData('Hockey/Anaheim/Sami Vatanen');
filterData('Hockey/Anaheim/Simon Despres');
filterData('Hockey/Anaheim/Tim Jackman');
filterData('Hockey/Anaheim/Tomas Fleischmann');
filterData('Hockey/Arizona/Anders Lindback');
filterData('Hockey/Arizona/Andrew Campbell');
filterData('Hockey/Arizona/BJ Crombeen');
filterData('Hockey/Arizona/Connor Murphy');
filterData('Hockey/Arizona/Craig Cunningham');
filterData('Hockey/Arizona/David Moss');
filterData('Hockey/Arizona/Joe Vitale');
filterData('Hockey/Arizona/John Moore');
filterData('Hockey/Arizona/Jordan Szwarz');
filterData('Hockey/Arizona/Klas Dahlbeck');
filterData('Hockey/Arizona/Kyle Chipchura');
filterData('Hockey/Arizona/Louis Domingue');
filterData('Hockey/Arizona/Mark Arcobello');
filterData('Hockey/Arizona/Martin Erat');
filterData('Hockey/Arizona/Martin Hanzal');
filterData('Hockey/Arizona/Max Domi');
filterData('Hockey/Arizona/Michael Stone');
filterData('Hockey/Arizona/Mike Smith');
filterData('Hockey/Arizona/Oliver Ekman-Larsson');
filterData('Hockey/Arizona/Sam Gagner');
filterData('Hockey/Arizona/Shane Doan');
filterData('Hockey/Arizona/Tobias Rieder');
filterData('Hockey/Arizona/Tye McGinn');
filterData('Hockey/Boston/Adam McQuaid');
filterData('Hockey/Boston/Brad Marchand');
filterData('Hockey/Boston/Brett Connolly');
filterData('Hockey/Boston/Brian Ferlin');
filterData('Hockey/Boston/Chris Kelly');
filterData('Hockey/Boston/Daniel Paille');
filterData('Hockey/Boston/David Krejci');
filterData('Hockey/Boston/Dennis Seidenberg');
filterData('Hockey/Boston/Gregory Campbell');
filterData('Hockey/Boston/Kevan Miller');
filterData('Hockey/Boston/Loui Eriksson');
filterData('Hockey/Boston/Matt Bartkowski');
filterData('Hockey/Boston/Max Talbot');
filterData('Hockey/Boston/Milan Lucic');
filterData('Hockey/Boston/Niklas Svedberg');
filterData('Hockey/Boston/Patrice Bergeron');
filterData('Hockey/Boston/Reilly Smith');
filterData('Hockey/Boston/Ryan Spooner');
filterData('Hockey/Boston/Torey Krug');
filterData('Hockey/Boston/Tuukka Rask');
filterData('Hockey/Boston/Zdeno Chara');
filterData('Hockey/Buffalo/Andre Benoit');
filterData('Hockey/Buffalo/Andrej Meszaros');
filterData('Hockey/Buffalo/Brian Gionta');
filterData('Hockey/Buffalo/Cody Hodgson');
filterData('Hockey/Buffalo/Cody McCormick');
filterData('Hockey/Buffalo/Jack Eichel');
filterData('Hockey/Buffalo/Jerry DAmigo');
filterData('Hockey/Buffalo/Johan Larsson');
filterData('Hockey/Buffalo/Josh Gorges');
filterData('Hockey/Buffalo/Marcus Foligno');
filterData('Hockey/Buffalo/Matt Ellis');
filterData('Hockey/Buffalo/Matt Moulson');
filterData('Hockey/Buffalo/Nicolas Deslauriers');
filterData('Hockey/Buffalo/Nikita Zadorov');
filterData('Hockey/Buffalo/Patrick Kaleta');
filterData('Hockey/Buffalo/Rasmus Ristolainen');
filterData('Hockey/Buffalo/Ryan OReilly');
filterData('Hockey/Buffalo/Tim Schaller');
filterData('Hockey/Buffalo/Tyler Ennis');
filterData('Hockey/Buffalo/Tyson Strachan');
filterData('Hockey/Buffalo/Zac Dalpe');
filterData('Hockey/Buffalo/Zach Bogosian');
filterData('Hockey/Buffalo/Zemgus Girgensons');
filterData('Hockey/Calgary/Brandon Bollig');
filterData('Hockey/Calgary/Chad Johnson');
filterData('Hockey/Calgary/Corey Potter');
filterData('Hockey/Calgary/David Jones');
filterData('Hockey/Calgary/David Schlemko');
filterData('Hockey/Calgary/Dennis Wideman');
filterData('Hockey/Calgary/Deryk Engelland');
filterData('Hockey/Calgary/Drew Shore');
filterData('Hockey/Calgary/Emile Poirier');
filterData('Hockey/Calgary/Jiri Hudler');
filterData('Hockey/Calgary/Joe Colborne');
filterData('Hockey/Calgary/Johnny Gaudreau');
filterData('Hockey/Calgary/Josh Jooris');
filterData('Hockey/Calgary/Ladislav Smid');
filterData('Hockey/Calgary/Lance Bouma');
filterData('Hockey/Calgary/Mark Giordano');
filterData('Hockey/Calgary/Mason Raymond');
filterData('Hockey/Calgary/Matt Stajan');
filterData('Hockey/Calgary/Michael Ferland');
filterData('Hockey/Calgary/Mikael Backlund');
filterData('Hockey/Calgary/Paul Byron');
filterData('Hockey/Calgary/Raphael Diaz');
filterData('Hockey/Calgary/Sean Monahan');
filterData('Hockey/Calgary/TJ Brodie');
filterData('Hockey/Carolina/Andrej Nestrasil');
filterData('Hockey/Carolina/Brad Malone');
filterData('Hockey/Carolina/Brett Bellemore');
filterData('Hockey/Carolina/Cam Ward');
filterData('Hockey/Carolina/Chris Terry');
filterData('Hockey/Carolina/Eddie Lack');
filterData('Hockey/Carolina/Elias Lindholm');
filterData('Hockey/Carolina/Eric Staal');
filterData('Hockey/Carolina/Jack Hillen');
filterData('Hockey/Carolina/Jay McClement');
filterData('Hockey/Carolina/Jeff Skinner');
filterData('Hockey/Carolina/Jordan Staal');
filterData('Hockey/Carolina/Justin Faulk');
filterData('Hockey/Carolina/Michal Jordan');
filterData('Hockey/Carolina/Nathan Gerbe');
filterData('Hockey/Carolina/Patrick Dwyer');
filterData('Hockey/Carolina/Rasmus Rissanen');
filterData('Hockey/Carolina/Riley Nash');
filterData('Hockey/Carolina/Ron Hainsey');
filterData('Hockey/Carolina/Ryan Murphy');
filterData('Hockey/Carolina/Victor Rask');
filterData('Hockey/Chicago/Andrew Desjardins');
filterData('Hockey/Chicago/Andrew Shaw');
filterData('Hockey/Chicago/Antoine Vermette');
filterData('Hockey/Chicago/Artemi Panarin');
filterData('Hockey/Chicago/Brad Richards');
filterData('Hockey/Chicago/Brandon Saad');
filterData('Hockey/Chicago/Brent Seabrook');
filterData('Hockey/Chicago/Bryan Bickell');
filterData('Hockey/Chicago/Daniel Carcillo');
filterData('Hockey/Chicago/David Rundblad');
filterData('Hockey/Chicago/Duncan Keith');
filterData('Hockey/Chicago/Johnny Oduya');
filterData('Hockey/Chicago/Jonathan Toews Patrick Kane');
filterData('Hockey/Chicago/Jonathan Toews');
filterData('Hockey/Chicago/Kimmo Timonen');
filterData('Hockey/Chicago/Marcus Kruger');
filterData('Hockey/Chicago/Marian Hossa');
filterData('Hockey/Chicago/Michal Rozsival');
filterData('Hockey/Chicago/Niklas Hjalmarsson');
filterData('Hockey/Chicago/Patrick Kane');
filterData('Hockey/Chicago/Patrick Sharp');
filterData('Hockey/Chicago/Ray Emery');
filterData('Hockey/Chicago/Scott Darling');
filterData('Hockey/Chicago/Teuvo Teravainen');
filterData('Hockey/Chicago/Trevor van Riemsdyk');
filterData('Hockey/Colorado/Borna Rendulic');
filterData('Hockey/Colorado/Brad Stuart');
filterData('Hockey/Colorado/Cody McLeod');
filterData('Hockey/Colorado/Daniel Briere');
filterData('Hockey/Colorado/Dennis Everberg');
filterData('Hockey/Colorado/Erik Johnson');
filterData('Hockey/Colorado/Freddie Hamilton');
filterData('Hockey/Colorado/Gabriel Landeskog');
filterData('Hockey/Colorado/Jan Hejda');
filterData('Hockey/Colorado/Jarome Iginla');
filterData('Hockey/Colorado/Jesse Winchester');
filterData('Hockey/Colorado/Joey Hishon');
filterData('Hockey/Colorado/John Mitchell');
filterData('Hockey/Colorado/Jordan Caron');
filterData('Hockey/Colorado/Matt Ducehne');
filterData('Hockey/Colorado/Matt Duchene');
filterData('Hockey/Colorado/Nate Guenin');
filterData('Hockey/Colorado/Nathan MacKinnon');
filterData('Hockey/Colorado/Nathan Mackinnon Jarome Iginla');
filterData('Hockey/Colorado/Nick Holden');
filterData('Hockey/Colorado/Patrick Bordeleau');
filterData('Hockey/Colorado/Ryan Wilson');
filterData('Hockey/Colorado/Semyon Varlamov');
filterData('Hockey/Colorado/Tyson Barrie');
filterData('Hockey/Colorado/Zach Redmond');
filterData('Hockey/Columbus/Alexander Wennberg');
filterData('Hockey/Columbus/Artem Anisimov');
filterData('Hockey/Columbus/Boone Jenner');
filterData('Hockey/Columbus/Cam Atkinson');
filterData('Hockey/Columbus/Cody Goloubef');
filterData('Hockey/Columbus/Curtis McElhinney');
filterData('Hockey/Columbus/Dalton Prout');
filterData('Hockey/Columbus/David Clarkson');
filterData('Hockey/Columbus/David Savard');
filterData('Hockey/Columbus/Fedor Tyutin');
filterData('Hockey/Columbus/Jack Johnson');
filterData('Hockey/Columbus/Jack Skille');
filterData('Hockey/Columbus/Jared Boll');
filterData('Hockey/Columbus/Justin Falk');
filterData('Hockey/Columbus/Kevin Connauton');
filterData('Hockey/Columbus/Marko Dano');
filterData('Hockey/Columbus/Matt Calvert');
filterData('Hockey/Columbus/Nick Foligno');
filterData('Hockey/Columbus/Rene Bourque');
filterData('Hockey/Columbus/Ryan Johansen');
filterData('Hockey/Columbus/Ryan Murray');
filterData('Hockey/Columbus/Scott Hartnell');
filterData('Hockey/Columbus/Sergei Bobrovsky');
filterData('Hockey/Dallas/Ales Hemsky');
filterData('Hockey/Dallas/Antoine Roussel');
filterData('Hockey/Dallas/Brett Ritchie');
filterData('Hockey/Dallas/Cody Eakin');
filterData('Hockey/Dallas/Colton Sceviour');
filterData('Hockey/Dallas/Curtis McKenzie');
filterData('Hockey/Dallas/Jamie Benn');
filterData('Hockey/Dallas/Jason Demers');
filterData('Hockey/Dallas/Jason Spezza');
filterData('Hockey/Dallas/John Klingberg');
filterData('Hockey/Dallas/Jordie Benn');
filterData('Hockey/Dallas/Jyrki Jokipakka');
filterData('Hockey/Dallas/Kari Lehtonen');
filterData('Hockey/Dallas/Patrick Eaves');
filterData('Hockey/Dallas/Patrik Nemeth');
filterData('Hockey/Dallas/Rich Peverley');
filterData('Hockey/Dallas/Shawn Horcoff');
filterData('Hockey/Dallas/Travis Moen');
filterData('Hockey/Dallas/Tyler Seguin');
filterData('Hockey/Dallas/Valeri Nichushkin');
filterData('Hockey/Dallas/Vernon Fiddler');
filterData('Hockey/Detroit/Alexey Marchenko');
filterData('Hockey/Detroit/Brendan Smith');
filterData('Hockey/Detroit/Daniel Cleary');
filterData('Hockey/Detroit/Danny DeKeyser');
filterData('Hockey/Detroit/Darren Helm');
filterData('Hockey/Detroit/Drew Miller');
filterData('Hockey/Detroit/Dylan Larkin');
filterData('Hockey/Detroit/Erik Cole');
filterData('Hockey/Detroit/Gustav Nyquist');
filterData('Hockey/Detroit/Henrik Zetterberg');
filterData('Hockey/Detroit/Jimmy Howard');
filterData('Hockey/Detroit/Joakim Andersson');
filterData('Hockey/Detroit/Johan Franzen');
filterData('Hockey/Detroit/Jonathan Ericsson');
filterData('Hockey/Detroit/Justin Abdelkader');
filterData('Hockey/Detroit/Kyle Quincey');
filterData('Hockey/Detroit/Luke Glendening');
filterData('Hockey/Detroit/Marek Zidlicky');
filterData('Hockey/Detroit/Niklas Kronwall');
filterData('Hockey/Detroit/Pavel Datsyuk Henrik Zetterberg');
filterData('Hockey/Detroit/Pavel Datsyuk');
filterData('Hockey/Detroit/Riley Sheahan');
filterData('Hockey/Detroit/Stephen Weiss');
filterData('Hockey/Detroit/Tomas Jurco');
filterData('Hockey/Detroit/Tomas Tatar');
filterData('Hockey/Detroit/Xavier Ouellet');
filterData('Hockey/Edmonton/Connor McDavid');
filterData('Hockey/Edmonton/Jonas Gustavsson');
filterData('Hockey/Edmonton/Jordan Eberle');
filterData('Hockey/Edmonton/Ryan Nugent-Hopkins');
filterData('Hockey/Edmonton/Taylor Hall');
filterData('Hockey/Florida/Aaron Ekblad');
filterData('Hockey/Florida/Aleksander Barkov');
filterData('Hockey/Florida/Alex Petrovic');
filterData('Hockey/Florida/Brad Boyes');
filterData('Hockey/Florida/Brandon Pirri');
filterData('Hockey/Florida/Brian Campbell');
filterData('Hockey/Florida/Derek MacKenzie');
filterData('Hockey/Florida/Dmitry Kulikov');
filterData('Hockey/Florida/Jaromir Jagr');
filterData('Hockey/Florida/Jonathan Huberdeau');
filterData('Hockey/Florida/Jussi Jokinen');
filterData('Hockey/Florida/Nick Bjugstad');
filterData('Hockey/Florida/Reto Berra');
filterData('Hockey/Florida/Roberto Luongo');
filterData('Hockey/Florida/Sam Brittain');
filterData('Hockey/Florida/Scottie Upshall');
filterData('Hockey/Florida/Shawn Thornton');
filterData('Hockey/Florida/Steven Kampfer');
filterData('Hockey/Florida/Vincent Trocheck');
filterData('Hockey/Florida/Willie Mitchell');
filterData('Hockey/Los Angeles/Alec Martinez');
filterData('Hockey/Los Angeles/Andrej Sekera');
filterData('Hockey/Los Angeles/Andy Andreoff');
filterData('Hockey/Los Angeles/Anze Kopitar');
filterData('Hockey/Los Angeles/Brayden McNabb');
filterData('Hockey/Los Angeles/Drew Doughty');
filterData('Hockey/Los Angeles/Dustin Brown');
filterData('Hockey/Los Angeles/Dwight King');
filterData('Hockey/Los Angeles/Jake Muzzin');
filterData('Hockey/Los Angeles/Jamie McBain');
filterData('Hockey/Los Angeles/Jarret Stoll');
filterData('Hockey/Los Angeles/Jeff Carter');
filterData('Hockey/Los Angeles/Jhonas Enroth');
filterData('Hockey/Los Angeles/Jonathan Quick');
filterData('Hockey/Los Angeles/Jordan Nolan');
filterData('Hockey/Los Angeles/Justin Williams');
filterData('Hockey/Los Angeles/Kyle Clifford');
filterData('Hockey/Los Angeles/Marian Gaborik');
filterData('Hockey/Los Angeles/Matt Greene');
filterData('Hockey/Los Angeles/Mike Richards');
filterData('Hockey/Los Angeles/Nick Shore');
filterData('Hockey/Los Angeles/Robyn Regehr');
filterData('Hockey/Los Angeles/Tanner Pearson');
filterData('Hockey/Los Angeles/Trevor Lewis');
filterData('Hockey/Los Angeles/Tyler Toffoli');
filterData('Hockey/Minnesota/Charlie Coyle');
filterData('Hockey/Minnesota/Christian Folin');
filterData('Hockey/Minnesota/Darcy Kuemper');
filterData('Hockey/Minnesota/Devan Dubnyk');
filterData('Hockey/Minnesota/Erik Haula');
filterData('Hockey/Minnesota/Jared Spurgeon');
filterData('Hockey/Minnesota/Jason Pominville');
filterData('Hockey/Minnesota/Jason Zucker');
filterData('Hockey/Minnesota/Jonas Brodin');
filterData('Hockey/Minnesota/Jordan Leopold');
filterData('Hockey/Minnesota/Jordan Schroeder');
filterData('Hockey/Minnesota/Josh Harding');
filterData('Hockey/Minnesota/Justin Fontaine');
filterData('Hockey/Minnesota/Keith Ballard');
filterData('Hockey/Minnesota/Kyle Brodziak');
filterData('Hockey/Minnesota/Marco Scandella');
filterData('Hockey/Minnesota/Matt Cooke');
filterData('Hockey/Minnesota/Matt Dumba');
filterData('Hockey/Minnesota/Mikael Granlund');
filterData('Hockey/Minnesota/Mikko Koivu Zach Parise');
filterData('Hockey/Minnesota/Mikko Koivu');
filterData('Hockey/Minnesota/Nate Prosser');
filterData('Hockey/Minnesota/Nino Niederreiter');
filterData('Hockey/Minnesota/Ryan Carter');
filterData('Hockey/Minnesota/Ryan Suter');
filterData('Hockey/Minnesota/Sean Bergenheim');
filterData('Hockey/Minnesota/Thomas Vanek');
filterData('Hockey/Minnesota/Zach Parise');
filterData('Hockey/Montreal/Al Montoya');
filterData('Hockey/Montreal/Alex Galchenyuk');
filterData('Hockey/Montreal/Alexei Emelin');
filterData('Hockey/Montreal/Andrei Markov');
filterData('Hockey/Montreal/Brendan Gallagher');
filterData('Hockey/Montreal/Brian Flynn');
filterData('Hockey/Montreal/Carey Price');
filterData('Hockey/Montreal/Dale Weise');
filterData('Hockey/Montreal/David Desharnais');
filterData('Hockey/Montreal/Dustin Tokarski');
filterData('Hockey/Montreal/Greg Pateryn');
filterData('Hockey/Montreal/Jacob DeLaRose');
filterData('Hockey/Montreal/Jeff Petry');
filterData('Hockey/Montreal/Lars Eller');
filterData('Hockey/Montreal/Manny Malhotra');
filterData('Hockey/Montreal/Max Pacioretty');
filterData('Hockey/Montreal/Mike Weaver');
filterData('Hockey/Montreal/Nathan Beaulieu');
filterData('Hockey/Montreal/PK Subban');
filterData('Hockey/Montreal/Pierre-Alexandre Parenteau');
filterData('Hockey/Montreal/Sergei Gonchar');
filterData('Hockey/Montreal/Tom Gilbert');
filterData('Hockey/Montreal/Tomas Plekanec Max Pacioretty');
filterData('Hockey/Montreal/Tomas Plekanec');
filterData('Hockey/Montreal/Torrey Mitchell');
filterData('Hockey/Nashville/Anton Volchenkov');
filterData('Hockey/Nashville/Calle Jarnkrok');
filterData('Hockey/Nashville/Carter Hutton');
filterData('Hockey/Nashville/Cody Franson');
filterData('Hockey/Nashville/Colin Wilson');
filterData('Hockey/Nashville/Craig Smith');
filterData('Hockey/Nashville/Eric Nystrom');
filterData('Hockey/Nashville/Filip Forsberg');
filterData('Hockey/Nashville/Gabriel Bourque');
filterData('Hockey/Nashville/James Neal');
filterData('Hockey/Nashville/Matt Cullen');
filterData('Hockey/Nashville/Mattias Ekholm');
filterData('Hockey/Nashville/Mike Fisher');
filterData('Hockey/Nashville/Mike Ribeiro James Neal');
filterData('Hockey/Nashville/Mike Ribeiro');
filterData('Hockey/Nashville/Paul Gaustad');
filterData('Hockey/Nashville/Pekka Rinne');
filterData('Hockey/Nashville/Roman Josi');
filterData('Hockey/Nashville/Ryan Ellis');
filterData('Hockey/Nashville/Seth Jones');
filterData('Hockey/Nashville/Shea Weber');
filterData('Hockey/Nashville/Victor Bartley');
filterData('Hockey/Nashville/Viktor Stalberg');
filterData('Hockey/New Jersey/Adam Henrique');
filterData('Hockey/New Jersey/Adam Larsson');
filterData('Hockey/New Jersey/Bryce Salvador');
filterData('Hockey/New Jersey/Cory Schneider');
filterData('Hockey/New Jersey/Dainius Zubrus');
filterData('Hockey/New Jersey/Jacob Josefson');
filterData('Hockey/New Jersey/Jon Merrill');
filterData('Hockey/New Jersey/Jordin Tootoo');
filterData('Hockey/New Jersey/Keith Kinkaid');
filterData('Hockey/New Jersey/Mark Fraser');
filterData('Hockey/New Jersey/Martin Havlat');
filterData('Hockey/New Jersey/Michael Ryder');
filterData('Hockey/New Jersey/Mike Cammalleri');
filterData('Hockey/New Jersey/Patrik Elias');
filterData('Hockey/New Jersey/Peter Harrold');
filterData('Hockey/New Jersey/Ryane Clowe');
filterData('Hockey/New Jersey/Scott Gomez');
filterData('Hockey/New Jersey/Stephen Gionta');
filterData('Hockey/New Jersey/Steve Bernier');
filterData('Hockey/New Jersey/Travis Zajac');
filterData('Hockey/New Jersey/Tuomo Ruutu');
filterData('Hockey/New York/Anders Lee');
filterData('Hockey/New York/Anthony Duclair');
filterData('Hockey/New York/Brian Strait');
filterData('Hockey/New York/Brock Nelson');
filterData('Hockey/New York/Cal Clutterbuck');
filterData('Hockey/New York/Calvin De Haan');
filterData('Hockey/New York/Casey Cizikas');
filterData('Hockey/New York/Chris Kreider');
filterData('Hockey/New York/Colin McDonald');
filterData('Hockey/New York/Dan Boyle');
filterData('Hockey/New York/Dan Girardi');
filterData('Hockey/New York/Daniel Girardi');
filterData('Hockey/New York/Derek Stepan');
filterData('Hockey/New York/Derick Brassard');
filterData('Hockey/New York/Dominic Moore');
filterData('Hockey/New York/Eric Boulton');
filterData('Hockey/New York/Frans Nielsen');
filterData('Hockey/New York/Henrik Lundqvist');
filterData('Hockey/New York/JT Miller');
filterData('Hockey/New York/James Sheppard');
filterData('Hockey/New York/Jaroslav Halak');
filterData('Hockey/New York/Jesper Fast');
filterData('Hockey/New York/John Tavares');
filterData('Hockey/New York/Johnny Boychuk');
filterData('Hockey/New York/Josh Bailey');
filterData('Hockey/New York/Kael Mouillierat');
filterData('Hockey/New York/Kevin Hayes');
filterData('Hockey/New York/Kevin Klein');
filterData('Hockey/New York/Kyle Okposo');
filterData('Hockey/New York/Lubomir Visnovsky');
filterData('Hockey/New York/Luke John');
filterData('Hockey/New York/Mackenzie Skapski');
filterData('Hockey/New York/Marc Staal');
filterData('Hockey/New York/Martin St Louis');
filterData('Hockey/New York/Mats Zuccarello');
filterData('Hockey/New York/Matt Donovan');
filterData('Hockey/New York/Matt Hunwick');
filterData('Hockey/New York/Matt Martin');
filterData('Hockey/New York/Mikhail Grabovski');
filterData('Hockey/New York/Nick Leddy');
filterData('Hockey/New York/Nikolay Kulemin');
filterData('Hockey/New York/Rick Nash Martin St Louis');
filterData('Hockey/New York/Rick Nash');
filterData('Hockey/New York/Ryan McDonagh');
filterData('Hockey/New York/Ryan Strome');
filterData('Hockey/New York/Tanner Glass');
filterData('Hockey/New York/Thomas Greiss');
filterData('Hockey/New York/Thomas Hickey');
filterData('Hockey/New York/Travis Hamonic');
filterData('Hockey/New York/Tyler Kennedy');
filterData('Hockey/Ottawa/Alex Chiasson');
filterData('Hockey/Ottawa/Andrew Hammond');
filterData('Hockey/Ottawa/Bobby Ryan');
filterData('Hockey/Ottawa/Chris Neil');
filterData('Hockey/Ottawa/Chris Phillips');
filterData('Hockey/Ottawa/Clarke MacArthur Bobby Ryan');
filterData('Hockey/Ottawa/Cody Ceci');
filterData('Hockey/Ottawa/Craig Anderson');
filterData('Hockey/Ottawa/Curtis Lazar');
filterData('Hockey/Ottawa/Erik Condra');
filterData('Hockey/Ottawa/Erik Karlsson');
filterData('Hockey/Ottawa/Jean-Gabriel Pageau');
filterData('Hockey/Ottawa/Kyle Turris');
filterData('Hockey/Ottawa/Marc Methot');
filterData('Hockey/Ottawa/Mark Borowiecki');
filterData('Hockey/Ottawa/Mark Stone');
filterData('Hockey/Ottawa/Matt Puempel');
filterData('Hockey/Ottawa/Mika Zibanejad');
filterData('Hockey/Ottawa/Mike Hoffman');
filterData('Hockey/Ottawa/Patrick Wiercioch');
filterData('Hockey/Ottawa/Zack Smith');
filterData('Hockey/Philadelphia/Andrew MacDonald');
filterData('Hockey/Philadelphia/Brandon Manning');
filterData('Hockey/Philadelphia/Brayden Schenn');
filterData('Hockey/Philadelphia/Carlo Colaiacovo');
filterData('Hockey/Philadelphia/Chris VandeVelde');
filterData('Hockey/Philadelphia/Claude Giroux Jakub Voracek');
filterData('Hockey/Philadelphia/Claude Giroux');
filterData('Hockey/Philadelphia/Jakub Voracek');
filterData('Hockey/Philadelphia/Luke Schenn');
filterData('Hockey/Philadelphia/Mark Streit');
filterData('Hockey/Philadelphia/Matt Read');
filterData('Hockey/Philadelphia/Michael Del Zotto');
filterData('Hockey/Philadelphia/Michael Raffl');
filterData('Hockey/Philadelphia/Michal Neuvirth');
filterData('Hockey/Philadelphia/Nick Cousins');
filterData('Hockey/Philadelphia/Nick Schultz');
filterData('Hockey/Philadelphia/Nicklas Grossmann');
filterData('Hockey/Philadelphia/Pierre-Edouard Bellemare');
filterData('Hockey/Philadelphia/RJ Umberger');
filterData('Hockey/Philadelphia/Ryan White');
filterData('Hockey/Philadelphia/Sean Couturier');
filterData('Hockey/Philadelphia/Shayne Gostisbehere');
filterData('Hockey/Philadelphia/Steve Mason');
filterData('Hockey/Philadelphia/Vincent Lecavalier');
filterData('Hockey/Philadelphia/Wayne Simmonds');
filterData('Hockey/Philadelphia/Zac Rinaldo');
filterData('Hockey/Pittsburgh/Andrew Ebbett');
filterData('Hockey/Pittsburgh/Beau Bennett');
filterData('Hockey/Pittsburgh/Bryan Rust');
filterData('Hockey/Pittsburgh/Chris Kunitz');
filterData('Hockey/Pittsburgh/Craig Adams');
filterData('Hockey/Pittsburgh/David Perron');
filterData('Hockey/Pittsburgh/Evgeni Malkin');
filterData('Hockey/Pittsburgh/Ian Cole');
filterData('Hockey/Pittsburgh/Kris LeTang');
filterData('Hockey/Pittsburgh/Kris Letang');
filterData('Hockey/Pittsburgh/Marc-Andre Fleury');
filterData('Hockey/Pittsburgh/Maxim Lapierre');
filterData('Hockey/Pittsburgh/Olli Maatta');
filterData('Hockey/Pittsburgh/Pascal Dupuis');
filterData('Hockey/Pittsburgh/Patric Hornqvist');
filterData('Hockey/Pittsburgh/Paul Martin');
filterData('Hockey/Pittsburgh/Sidney Crosby Evgeni Malkin');
filterData('Hockey/Pittsburgh/Sidney Crosby');
filterData('Hockey/Pittsburgh/Steve Downie');
filterData('Hockey/San Jose/Brent Burns');
filterData('Hockey/San Jose/Joe Pavelski');
filterData('Hockey/San Jose/Joe Thornton Joe Pavelski');
filterData('Hockey/San Jose/Joe Thornton');
filterData('Hockey/San Jose/Logan Couture');
filterData('Hockey/San Jose/Marc-Edouard Vlasic');
filterData('Hockey/San Jose/Martin Jones');
filterData('Hockey/San Jose/Patrick Marleau');
filterData('Hockey/St. Louis/Alex Pietrangelo');
filterData('Hockey/St. Louis/Alexander Steen');
filterData('Hockey/St. Louis/Barret Jackman');
filterData('Hockey/St. Louis/Brian Elliott');
filterData('Hockey/St. Louis/Carl Gunnarsson');
filterData('Hockey/St. Louis/Chris Butler');
filterData('Hockey/St. Louis/Chris Porter');
filterData('Hockey/St. Louis/David Backes');
filterData('Hockey/St. Louis/Dmitrij Jaskin');
filterData('Hockey/St. Louis/Jaden Schwartz');
filterData('Hockey/St. Louis/Jake Allen');
filterData('Hockey/St. Louis/Jay Bouwmeester');
filterData('Hockey/St. Louis/Jori Lehtera');
filterData('Hockey/St. Louis/Kevin Shattenkirk');
filterData('Hockey/St. Louis/Marcel Goc');
filterData('Hockey/St. Louis/Olli Jokinen');
filterData('Hockey/St. Louis/Patrik Berglund');
filterData('Hockey/St. Louis/Paul Stastny');
filterData('Hockey/St. Louis/Petteri Lindbohm');
filterData('Hockey/St. Louis/Robert Bortuzzo');
filterData('Hockey/St. Louis/Ryan Reaves');
filterData('Hockey/St. Louis/Steve Ott');
filterData('Hockey/St. Louis/TJ Oshie');
filterData('Hockey/St. Louis/Vladimir Tarasenko');
filterData('Hockey/St. Louis/Zbynek Michalek');
filterData('Hockey/Tampa Bay/Alex Killorn');
filterData('Hockey/Tampa Bay/Andrei Vasilevskiy');
filterData('Hockey/Tampa Bay/Andrej Sustr');
filterData('Hockey/Tampa Bay/Anton Stralman');
filterData('Hockey/Tampa Bay/Ben Bishop');
filterData('Hockey/Tampa Bay/Braydon Coburn');
filterData('Hockey/Tampa Bay/Brenden Morrow');
filterData('Hockey/Tampa Bay/Brian Boyle');
filterData('Hockey/Tampa Bay/Cedric Paquette');
filterData('Hockey/Tampa Bay/JT Brown');
filterData('Hockey/Tampa Bay/Jason Garrison');
filterData('Hockey/Tampa Bay/Jonathan Drouin');
filterData('Hockey/Tampa Bay/Mark Barberio');
filterData('Hockey/Tampa Bay/Matthew Carle');
filterData('Hockey/Tampa Bay/Mike Angelidis');
filterData('Hockey/Tampa Bay/Nikita Kucherov');
filterData('Hockey/Tampa Bay/Nikita Nesterov');
filterData('Hockey/Tampa Bay/Ondrej Palat');
filterData('Hockey/Tampa Bay/Radko Gudas');
filterData('Hockey/Tampa Bay/Ryan Callahan');
filterData('Hockey/Tampa Bay/Steven Stamkos Ryan Callahan');
filterData('Hockey/Tampa Bay/Steven Stamkos');
filterData('Hockey/Tampa Bay/Tyler Johnson');
filterData('Hockey/Tampa Bay/Valterri Filppula');
filterData('Hockey/Tampa Bay/Valterri Flippula');
filterData('Hockey/Tampa Bay/Valtteri Filppula');
filterData('Hockey/Tampa Bay/Victor Hedman');
filterData('Hockey/Tampa Bay/Vladislav Namestnikov');
filterData('Hockey/Toronto/Dion Phaneuf');
filterData('Hockey/Toronto/James Van Riemsdyk');
filterData('Hockey/Toronto/Joffrey Lupul');
filterData('Hockey/Toronto/Korbinian Holzer');
filterData('Hockey/Toronto/Leo Komarov');
filterData('Hockey/Toronto/Phil Kessel');
filterData('Hockey/Toronto/Tyler Bozak');
filterData('Hockey/Vancouver/Daniel Sedin and Henrik Sedin');
filterData('Hockey/Vancouver/Daniel Sedin');
filterData('Hockey/Vancouver/Eric Gudbranson');
filterData('Hockey/Vancouver/Henrik Sedin Daniel Sedin');
filterData('Hockey/Vancouver/Henrik Sedin');
filterData('Hockey/Vancouver/Kevin Bieksa');
filterData('Hockey/Vancouver/Mattias Ohlund');
filterData('Hockey/Vancouver/Nick Bonino');
filterData('Hockey/Vancouver/Radim Vrbata');
filterData('Hockey/Washington DC/Alex Ovechkin');
filterData('Hockey/Washington DC/Alexander Ovechkin');
filterData('Hockey/Washington DC/Braden Holtby');
filterData('Hockey/Washington DC/Dan Ellis');
filterData('Hockey/Washington DC/Evgeny Kuznetsov');
filterData('Hockey/Washington DC/John Carlson');
filterData('Hockey/Washington DC/Karl Alzner');
filterData('Hockey/Washington DC/Michael Latta Tom Wilson');
filterData('Hockey/Washington DC/Michael Latta');
filterData('Hockey/Washington DC/Mike Green');
filterData('Hockey/Washington DC/Nicklas Backstrom Alex Ovechkin');
filterData('Hockey/Washington DC/Nicklas Backstrom');
filterData('Hockey/Washington DC/Niklas Backstrom');
filterData('Hockey/Washington DC/Tom Wilson');
filterData('Hockey/Washington DC/Troy Brouwer');
filterData('Hockey/Winnipeg/Adam Lowry');
filterData('Hockey/Winnipeg/Adam Pardy');
filterData('Hockey/Winnipeg/Anthony Peluso');
filterData('Hockey/Winnipeg/Ben Chiarot');
filterData('Hockey/Winnipeg/Blake Wheeler');
filterData('Hockey/Winnipeg/Bryan Little');
filterData('Hockey/Winnipeg/Chris Driedger');
filterData('Hockey/Winnipeg/Drew Stafford');
filterData('Hockey/Winnipeg/Dustin Byfuglien');
filterData('Hockey/Winnipeg/Evander Kane');
filterData('Hockey/Winnipeg/Grant Clitsome');
filterData('Hockey/Winnipeg/Jacob Trouba');
filterData('Hockey/Winnipeg/Jay Harrison');
filterData('Hockey/Winnipeg/Jim Slater');
filterData('Hockey/Winnipeg/Jiri Tlusty');
filterData('Hockey/Winnipeg/Mark Scheifele');
filterData('Hockey/Winnipeg/Mark Stuart');
filterData('Hockey/Winnipeg/Mathieu Perreault');
filterData('Hockey/Winnipeg/Matt Halischuk');
filterData('Hockey/Winnipeg/Michael Frolik');
filterData('Hockey/Winnipeg/Michael Hutchinson');
filterData('Hockey/Winnipeg/Ondrej Pavelec');
filterData('Hockey/Winnipeg/Paul Postma');
filterData('Hockey/Winnipeg/TJ Galiardi');
filterData('Hockey/Winnipeg/Toby Enstrom');
filterData('Hockey/Winnipeg/Tyler Myers');
filterData('MMA/MMA/Amanda Bobby Cooper');
filterData('MMA/MMA/Fabricio Werdum');
filterData('MMA/MMA/Frank Mir');
filterData('MMA/MMA/Julianna Pe?ña');
filterData('MMA/MMA/Julianna Peña');
filterData('MMA/MMA/Julianna Pe’±a');
filterData('Throwbacks/Throwbacks/Andre Dawson');
filterData('Throwbacks/Throwbacks/Bernie Parent');
filterData('Throwbacks/Throwbacks/Brian Bosworth');
filterData('Throwbacks/Throwbacks/Bruce Lee');
filterData('Throwbacks/Throwbacks/Clinton Portis');
filterData('Throwbacks/Throwbacks/Dwight Gooden');
filterData('Throwbacks/Throwbacks/Eric Dickerson');
filterData('Throwbacks/Throwbacks/Gary Payton');
filterData('Throwbacks/Throwbacks/Isaac Bruce');
filterData('Throwbacks/Throwbacks/Joe Greene');
filterData('Throwbacks/Throwbacks/Ladainian Tomlinson');
filterData('Throwbacks/Throwbacks/Martin Brodeur');
filterData('Throwbacks/Throwbacks/Olie Kolzig');
filterData('Throwbacks/Throwbacks/Patrick Willis');
filterData('Throwbacks/Throwbacks/Pavel Bure');
filterData('Throwbacks/Throwbacks/Ray Lewis');
filterData('Throwbacks/Throwbacks/Rick Mahorn');
filterData('Throwbacks/Throwbacks/Ron Santo');
filterData('Throwbacks/Throwbacks/Shawn Marion');
filterData('Throwbacks/Throwbacks/Spud Webb');
filterData('Throwbacks/Throwbacks/Steve Largent');
filterData('Throwbacks/Throwbacks/Terrell Owens');
filterData('Throwbacks/Throwbacks/Troy Polamalu');
filterData('Throwbacks/Throwbacks/Walkter Peyton');
filterData('Throwbacks/Throwbacks/Walter Payton');
filterData('Throwbacks/Throwbacks/Warren Sapp');
filterData('Throwbacks/Throwbacks/Wayne Chrebet');
filterData('Wrestling/Wrestling/Andre The Giant');
filterData('Wrestling/Wrestling/Andre the Giant');
filterData('Wrestling/Wrestling/Brutus The Barber Beefcake');
filterData('Wrestling/Wrestling/Hacksaw Jim Duggan');
filterData('Wrestling/Wrestling/Jake The Snake Roberts');
filterData('Wrestling/Wrestling/Jimmy Snuka');
filterData('Wrestling/Wrestling/Kevin Nash');
filterData('Wrestling/Wrestling/Macho Man Randy Savage');
filterData('Wrestling/Wrestling/Raven');
filterData('Wrestling/Wrestling/Road Warriors');
filterData('Wrestling/Wrestling/Rowdy Roddy Piper');
filterData('Wrestling/Wrestling/Ted DiBiase');
filterData('Wrestling/Wrestling/The British Bulldog');
filterData2('Anaheim/Hockey/Andrew Cogliano');
filterData2('Anaheim/Hockey/Cam Fowler');
filterData2('Anaheim/Hockey/Chris Wagner');
filterData2('Anaheim/Hockey/Clayton Stoner');
filterData2('Anaheim/Hockey/Corey Perry');
filterData2('Anaheim/Hockey/Dany Heatley');
filterData2('Anaheim/Hockey/Francois Beauchemin');
filterData2('Anaheim/Hockey/Frederik Andersen');
filterData2('Anaheim/Hockey/Hampus Lindholm');
filterData2('Anaheim/Hockey/Jakob Silfverberg');
filterData2('Anaheim/Hockey/John Gibson');
filterData2('Anaheim/Hockey/Jonas Hiller');
filterData2('Anaheim/Hockey/Josh Manson');
filterData2('Anaheim/Hockey/Matt Beleskey');
filterData2('Anaheim/Hockey/Michael Santorelli');
filterData2('Anaheim/Hockey/Nate Thompson');
filterData2('Anaheim/Hockey/Patrick Maroon');
filterData2('Anaheim/Hockey/Rickard Rakell');
filterData2('Anaheim/Hockey/Ryan Getzlaf Ryan Kesler');
filterData2('Anaheim/Hockey/Ryan Getzlaf');
filterData2('Anaheim/Hockey/Ryan Kesler');
filterData2('Anaheim/Hockey/Sami Vatanen');
filterData2('Anaheim/Hockey/Simon Despres');
filterData2('Anaheim/Hockey/Tim Jackman');
filterData2('Anaheim/Hockey/Tomas Fleischmann');
filterData2('Arizona/Baseball/AJ Pollock');
filterData2('Arizona/Baseball/David Peralta');
filterData2('Arizona/Baseball/Jean Segura');
filterData2('Arizona/Baseball/Patrick Corbin');
filterData2('Arizona/Baseball/Paul Goldschmidt');
filterData2('Arizona/Baseball/Robbie Ray');
filterData2('Arizona/Baseball/Shelby Miller');
filterData2('Arizona/Baseball/Zack Greinke');
filterData2('Arizona/Football/Andre Ellington');
filterData2('Arizona/Football/Brittan Golden');
filterData2('Arizona/Football/Calais Campbell');
filterData2('Arizona/Football/Carson Palmer Larry Fitzgerald');
filterData2('Arizona/Football/Carson Palmer Michael Floyd');
filterData2('Arizona/Football/Carson Palmer');
filterData2('Arizona/Football/Chandler Catanzaro');
filterData2('Arizona/Football/DJ Humphries');
filterData2('Arizona/Football/Deone Bucannon');
filterData2('Arizona/Football/Drew Stanton');
filterData2('Arizona/Football/Frostee Rucker');
filterData2('Arizona/Football/Jaron Brown');
filterData2('Arizona/Football/John Brown');
filterData2('Arizona/Football/Larry Fitzgerald');
filterData2('Arizona/Football/Michael Floyd');
filterData2('Arizona/Football/Patrick Peterson and Tyrann Mathieu');
filterData2('Arizona/Football/Patrick Peterson');
filterData2('Arizona/Football/Robert Nkemdiche');
filterData2('Arizona/Football/Rodney Gunter');
filterData2('Arizona/Football/Sean Weatherspoon');
filterData2('Arizona/Football/Tyrann Mathieu');
filterData2('Arizona/Hockey/Anders Lindback');
filterData2('Arizona/Hockey/Andrew Campbell');
filterData2('Arizona/Hockey/BJ Crombeen');
filterData2('Arizona/Hockey/Connor Murphy');
filterData2('Arizona/Hockey/Craig Cunningham');
filterData2('Arizona/Hockey/David Moss');
filterData2('Arizona/Hockey/Joe Vitale');
filterData2('Arizona/Hockey/John Moore');
filterData2('Arizona/Hockey/Jordan Szwarz');
filterData2('Arizona/Hockey/Klas Dahlbeck');
filterData2('Arizona/Hockey/Kyle Chipchura');
filterData2('Arizona/Hockey/Louis Domingue');
filterData2('Arizona/Hockey/Mark Arcobello');
filterData2('Arizona/Hockey/Martin Erat');
filterData2('Arizona/Hockey/Martin Hanzal');
filterData2('Arizona/Hockey/Max Domi');
filterData2('Arizona/Hockey/Michael Stone');
filterData2('Arizona/Hockey/Mike Smith');
filterData2('Arizona/Hockey/Oliver Ekman-Larsson');
filterData2('Arizona/Hockey/Sam Gagner');
filterData2('Arizona/Hockey/Shane Doan');
filterData2('Arizona/Hockey/Tobias Rieder');
filterData2('Arizona/Hockey/Tye McGinn');
filterData2('Atlanta/Baseball/Arodys Vizcaino');
filterData2('Atlanta/Baseball/Ender Inciarte');
filterData2('Atlanta/Baseball/Freddie Freeman');
filterData2('Atlanta/Baseball/Gordon Beckham');
filterData2('Atlanta/Baseball/Jason Grilli');
filterData2('Atlanta/Baseball/Julio Teheran');
filterData2('Atlanta/Baseball/Mallex Smith');
filterData2('Atlanta/Baseball/Nick Markakis');
filterData2('Atlanta/Football/Desmond Trufant');
filterData2('Atlanta/Football/Devin Hester');
filterData2('Atlanta/Football/Devonta Freeman');
filterData2('Atlanta/Football/Julio Jones');
filterData2('Atlanta/Football/Keanu Neal');
filterData2('Atlanta/Football/Kemal Ishmael');
filterData2('Atlanta/Football/Matt Bryant');
filterData2('Atlanta/Football/Matt Ryan Julio Jones');
filterData2('Atlanta/Football/Matt Ryan');
filterData2('Atlanta/Football/Patrick DiMarco');
filterData2('Atlanta/Football/Tevin Coleman');
filterData2('Atlanta/Football/Victor Beasley');
filterData2('Baltimore/Baseball/Chris David');
filterData2('Baltimore/Baseball/Kevin Gausman');
filterData2('Baltimore/Baseball/Manny Machado');
filterData2('Baltimore/Baseball/Mark Trumbo');
filterData2('Baltimore/Baseball/Matt Wieters');
filterData2('Baltimore/Baseball/Ubaldo Jimenez');
filterData2('Baltimore/Football/Breshad Perriman');
filterData2('Baltimore/Football/Bryn Renner');
filterData2('Baltimore/Football/CJ Mosley');
filterData2('Baltimore/Football/Chris Moore');
filterData2('Baltimore/Football/Crockett Gillmore');
filterData2('Baltimore/Football/Elvis Dumervil');
filterData2('Baltimore/Football/Joe Flacco');
filterData2('Baltimore/Football/Justin Forsett');
filterData2('Baltimore/Football/Justin Tucker');
filterData2('Baltimore/Football/Keenan Reynolds');
filterData2('Baltimore/Football/Kenneth Dixon');
filterData2('Baltimore/Football/Marshal Yanda');
filterData2('Baltimore/Football/Mike Wallace');
filterData2('Baltimore/Football/Ronnie Staley');
filterData2('Baltimore/Football/Ronnie Stanley');
filterData2('Baltimore/Football/Steve Smith Sr');
filterData2('Baltimore/Football/Tavon Young');
filterData2('Baltimore/Football/Terrell Suggs');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Al Kaline');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Al Lopez');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Barry Larkin');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Bill Mazeroski');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Billy Williams');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Bob Feller');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Brooks Robinson');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Bruce Sutter');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Cal Ripken Jr');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Catfish Hunter');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Dave Winfield');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Don Sutton');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Duke Snider');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Earl Weaver');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Eddie Mathews');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Eddie Murray');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Enos Slaughter');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Fergie Jenkins');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Gary Carter');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/George Brett');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Harmon Kilebrew');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Hoyt Wilhelm');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Jim Bunning');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Jim Palmer');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Johnny Bench');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Juan Marichal');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Larry Doby');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Lou Boudreau');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Lou Brock');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Nolan Ryan');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Orlando Cepeda');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Ozzie Smith');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Paul Molitor');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Phil Niekro');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Phil Rizzuto');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Red Schoendienst');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Reggie Jackson');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Rich Gossage');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Roberto Alomar');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Robin Roberts');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Robin Yount');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Rod Carew');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Rollie Fingers');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Ryne Sandberg');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Tom Lasorda');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Tom Seaver');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Tommy Lasorda');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Tony Gwynn');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Tony Perez');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Wade Boggs');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Warren Spahn');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Whitey Ford');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Willie McCovey');
filterData2('Baseball Hall of Fame/Baseball Hall of Fame/Willie Stargell');
filterData2('Boston/Baseball/Clay Buchholz');
filterData2('Boston/Baseball/Craig Kimbrel');
filterData2('Boston/Baseball/David Ortiz');
filterData2('Boston/Baseball/David Price');
filterData2('Boston/Baseball/Dustin Pedroia');
filterData2('Boston/Baseball/Jackie Bradley Jr');
filterData2('Boston/Baseball/Jackie Bradley');
filterData2('Boston/Baseball/Koji Uehara');
filterData2('Boston/Baseball/Mookie Betts');
filterData2('Boston/Baseball/Pablo Sandoval');
filterData2('Boston/Baseball/Steven Wright');
filterData2('Boston/Baseball/Travis Shaw');
filterData2('Boston/Baseball/Xander Bogaerts');
filterData2('Boston/Hockey/Adam McQuaid');
filterData2('Boston/Hockey/Brad Marchand');
filterData2('Boston/Hockey/Brett Connolly');
filterData2('Boston/Hockey/Brian Ferlin');
filterData2('Boston/Hockey/Chris Kelly');
filterData2('Boston/Hockey/Daniel Paille');
filterData2('Boston/Hockey/David Krejci');
filterData2('Boston/Hockey/Dennis Seidenberg');
filterData2('Boston/Hockey/Gregory Campbell');
filterData2('Boston/Hockey/Kevan Miller');
filterData2('Boston/Hockey/Loui Eriksson');
filterData2('Boston/Hockey/Matt Bartkowski');
filterData2('Boston/Hockey/Max Talbot');
filterData2('Boston/Hockey/Milan Lucic');
filterData2('Boston/Hockey/Niklas Svedberg');
filterData2('Boston/Hockey/Patrice Bergeron');
filterData2('Boston/Hockey/Reilly Smith');
filterData2('Boston/Hockey/Ryan Spooner');
filterData2('Boston/Hockey/Torey Krug');
filterData2('Boston/Hockey/Tuukka Rask');
filterData2('Boston/Hockey/Zdeno Chara');
filterData2('Buffalo/Football/Aaron Williams');
filterData2('Buffalo/Football/Cardale Jones');
filterData2('Buffalo/Football/Charles Clay');
filterData2('Buffalo/Football/Dan Carpenter');
filterData2('Buffalo/Football/EJ Manuel');
filterData2('Buffalo/Football/Jerry Hughes');
filterData2('Buffalo/Football/Jonathan Williams');
filterData2('Buffalo/Football/LeSean McCoy');
filterData2('Buffalo/Football/Marcell Dareus');
filterData2('Buffalo/Football/Mario Williams');
filterData2('Buffalo/Football/Ronald Darby');
filterData2('Buffalo/Football/Sammy Watkins');
filterData2('Buffalo/Football/Stephon Gilmore');
filterData2('Buffalo/Football/TJ Barnes');
filterData2('Buffalo/Football/Tyrod Taylor');
filterData2('Buffalo/Hockey/Andre Benoit');
filterData2('Buffalo/Hockey/Andrej Meszaros');
filterData2('Buffalo/Hockey/Brian Gionta');
filterData2('Buffalo/Hockey/Cody Hodgson');
filterData2('Buffalo/Hockey/Cody McCormick');
filterData2('Buffalo/Hockey/Jack Eichel');
filterData2('Buffalo/Hockey/Jerry DAmigo');
filterData2('Buffalo/Hockey/Johan Larsson');
filterData2('Buffalo/Hockey/Josh Gorges');
filterData2('Buffalo/Hockey/Marcus Foligno');
filterData2('Buffalo/Hockey/Matt Ellis');
filterData2('Buffalo/Hockey/Matt Moulson');
filterData2('Buffalo/Hockey/Nicolas Deslauriers');
filterData2('Buffalo/Hockey/Nikita Zadorov');
filterData2('Buffalo/Hockey/Patrick Kaleta');
filterData2('Buffalo/Hockey/Rasmus Ristolainen');
filterData2('Buffalo/Hockey/Ryan OReilly');
filterData2('Buffalo/Hockey/Tim Schaller');
filterData2('Buffalo/Hockey/Tyler Ennis');
filterData2('Buffalo/Hockey/Tyson Strachan');
filterData2('Buffalo/Hockey/Zac Dalpe');
filterData2('Buffalo/Hockey/Zach Bogosian');
filterData2('Buffalo/Hockey/Zemgus Girgensons');
filterData2('Calgary/Hockey/Brandon Bollig');
filterData2('Calgary/Hockey/Chad Johnson');
filterData2('Calgary/Hockey/Corey Potter');
filterData2('Calgary/Hockey/David Jones');
filterData2('Calgary/Hockey/David Schlemko');
filterData2('Calgary/Hockey/Dennis Wideman');
filterData2('Calgary/Hockey/Deryk Engelland');
filterData2('Calgary/Hockey/Drew Shore');
filterData2('Calgary/Hockey/Emile Poirier');
filterData2('Calgary/Hockey/Jiri Hudler');
filterData2('Calgary/Hockey/Joe Colborne');
filterData2('Calgary/Hockey/Johnny Gaudreau');
filterData2('Calgary/Hockey/Josh Jooris');
filterData2('Calgary/Hockey/Ladislav Smid');
filterData2('Calgary/Hockey/Lance Bouma');
filterData2('Calgary/Hockey/Mark Giordano');
filterData2('Calgary/Hockey/Mason Raymond');
filterData2('Calgary/Hockey/Matt Stajan');
filterData2('Calgary/Hockey/Michael Ferland');
filterData2('Calgary/Hockey/Mikael Backlund');
filterData2('Calgary/Hockey/Paul Byron');
filterData2('Calgary/Hockey/Raphael Diaz');
filterData2('Calgary/Hockey/Sean Monahan');
filterData2('Calgary/Hockey/TJ Brodie');
filterData2('Carolina/Football/Ben Jacobs');
filterData2('Carolina/Football/Brian Folkerts');
filterData2('Carolina/Football/Cam Newton Greg Olsen');
filterData2('Carolina/Football/Cam Newton');
filterData2('Carolina/Football/Devin Funchess');
filterData2('Carolina/Football/Ed Dickson');
filterData2('Carolina/Football/Greg Olsen');
filterData2('Carolina/Football/Jonathan Stewart');
filterData2('Carolina/Football/Josh Norman');
filterData2('Carolina/Football/Kelvin Benjamin');
filterData2('Carolina/Football/Kony Ealy');
filterData2('Carolina/Football/Kurt Coleman');
filterData2('Carolina/Football/Luke Kuechly');
filterData2('Carolina/Football/Mike Remmers');
filterData2('Carolina/Football/Mike Tolbert');
filterData2('Carolina/Football/Roman Harper');
filterData2('Carolina/Football/Shaq Thompson');
filterData2('Carolina/Football/Star Lotulelei');
filterData2('Carolina/Football/Ted Ginn Jr');
filterData2('Carolina/Football/Teddy Williams');
filterData2('Carolina/Football/Thomas Davis');
filterData2('Carolina/Hockey/Andrej Nestrasil');
filterData2('Carolina/Hockey/Brad Malone');
filterData2('Carolina/Hockey/Brett Bellemore');
filterData2('Carolina/Hockey/Cam Ward');
filterData2('Carolina/Hockey/Chris Terry');
filterData2('Carolina/Hockey/Eddie Lack');
filterData2('Carolina/Hockey/Elias Lindholm');
filterData2('Carolina/Hockey/Eric Staal');
filterData2('Carolina/Hockey/Jack Hillen');
filterData2('Carolina/Hockey/Jay McClement');
filterData2('Carolina/Hockey/Jeff Skinner');
filterData2('Carolina/Hockey/Jordan Staal');
filterData2('Carolina/Hockey/Justin Faulk');
filterData2('Carolina/Hockey/Michal Jordan');
filterData2('Carolina/Hockey/Nathan Gerbe');
filterData2('Carolina/Hockey/Patrick Dwyer');
filterData2('Carolina/Hockey/Rasmus Rissanen');
filterData2('Carolina/Hockey/Riley Nash');
filterData2('Carolina/Hockey/Ron Hainsey');
filterData2('Carolina/Hockey/Ryan Murphy');
filterData2('Carolina/Hockey/Victor Rask');
filterData2('Charity/Charity/Waterboys');
filterData2('Chicago/Baseball/Adam Eaton');
filterData2('Chicago/Baseball/Addison Russell');
filterData2('Chicago/Baseball/Albert Almora');
filterData2('Chicago/Baseball/Anthony Rizzo');
filterData2('Chicago/Baseball/Ben Zobrist');
filterData2('Chicago/Baseball/Brett Lawrie');
filterData2('Chicago/Baseball/Chris Sale');
filterData2('Chicago/Baseball/David Ross');
filterData2('Chicago/Baseball/Dexter Fowler');
filterData2('Chicago/Baseball/Jake Arrieta');
filterData2('Chicago/Baseball/Jason Hammel');
filterData2('Chicago/Baseball/Jason Heyward');
filterData2('Chicago/Baseball/Javier Baez');
filterData2('Chicago/Baseball/John Danks');
filterData2('Chicago/Baseball/Jon Lester');
filterData2('Chicago/Baseball/Jorge Soler');
filterData2('Chicago/Baseball/Jose Abreu');
filterData2('Chicago/Baseball/Jose Quintana');
filterData2('Chicago/Baseball/Justin Grimm');
filterData2('Chicago/Baseball/Kris Bryant');
filterData2('Chicago/Baseball/Kyle Hendricks');
filterData2('Chicago/Baseball/Kyle Schwarber');
filterData2('Chicago/Baseball/Melky Cabrera');
filterData2('Chicago/Baseball/Todd Frazier');
filterData2('Chicago/Baseball/Willson Contreras');
filterData2('Chicago/Football/Alshon Jeffery');
filterData2('Chicago/Football/Antrel Rolle');
filterData2('Chicago/Football/Brian Urlacher');
filterData2('Chicago/Football/Daniel Braverman');
filterData2('Chicago/Football/Jared Allen');
filterData2('Chicago/Football/Jay Cutler Alshon Jeffery');
filterData2('Chicago/Football/Jay Cutler Eddie Royal');
filterData2('Chicago/Football/Jay Cutler');
filterData2('Chicago/Football/Jeremiah Ratliff');
filterData2('Chicago/Football/Jeremy Langford');
filterData2('Chicago/Football/Jimmy Clausen');
filterData2('Chicago/Football/Jordan Howard');
filterData2('Chicago/Football/Kevin White');
filterData2('Chicago/Football/Kyle Fuller');
filterData2('Chicago/Football/Kyle Long');
filterData2('Chicago/Football/Leonard Floyd');
filterData2('Chicago/Football/Marquess Wilson');
filterData2('Chicago/Football/Pat ODonnell');
filterData2('Chicago/Football/Robbie Gould');
filterData2('Chicago/Football/Sherrick McManis');
filterData2('Chicago/Football/Taveze Calhoun');
filterData2('Chicago/Football/Thomas Gafford');
filterData2('Chicago/Football/Tim Jennings');
filterData2('Chicago/Football/Zach Miller');
filterData2('Chicago/Hockey/Andrew Desjardins');
filterData2('Chicago/Hockey/Andrew Shaw');
filterData2('Chicago/Hockey/Antoine Vermette');
filterData2('Chicago/Hockey/Artemi Panarin');
filterData2('Chicago/Hockey/Brad Richards');
filterData2('Chicago/Hockey/Brandon Saad');
filterData2('Chicago/Hockey/Brent Seabrook');
filterData2('Chicago/Hockey/Bryan Bickell');
filterData2('Chicago/Hockey/Daniel Carcillo');
filterData2('Chicago/Hockey/David Rundblad');
filterData2('Chicago/Hockey/Duncan Keith');
filterData2('Chicago/Hockey/Johnny Oduya');
filterData2('Chicago/Hockey/Jonathan Toews Patrick Kane');
filterData2('Chicago/Hockey/Jonathan Toews');
filterData2('Chicago/Hockey/Kimmo Timonen');
filterData2('Chicago/Hockey/Marcus Kruger');
filterData2('Chicago/Hockey/Marian Hossa');
filterData2('Chicago/Hockey/Michal Rozsival');
filterData2('Chicago/Hockey/Niklas Hjalmarsson');
filterData2('Chicago/Hockey/Patrick Kane');
filterData2('Chicago/Hockey/Patrick Sharp');
filterData2('Chicago/Hockey/Ray Emery');
filterData2('Chicago/Hockey/Scott Darling');
filterData2('Chicago/Hockey/Teuvo Teravainen');
filterData2('Chicago/Hockey/Trevor van Riemsdyk');
filterData2('Cincinnati/Baseball/Adam Duvall');
filterData2('Cincinnati/Baseball/Billy Hamilton');
filterData2('Cincinnati/Baseball/Brandon Phillips');
filterData2('Cincinnati/Baseball/Eugenio Suarez');
filterData2('Cincinnati/Baseball/Homer Bailey');
filterData2('Cincinnati/Baseball/Jay Bruce');
filterData2('Cincinnati/Baseball/Joey Votto');
filterData2('Cincinnati/Baseball/Zack Cozart');
filterData2('Cincinnati/Football/AJ Green');
filterData2('Cincinnati/Football/AJ Hawk');
filterData2('Cincinnati/Football/Adam Jones');
filterData2('Cincinnati/Football/Andrew Whitworth');
filterData2('Cincinnati/Football/Andy Dalton AJ Green');
filterData2('Cincinnati/Football/Andy Dalton');
filterData2('Cincinnati/Football/Carlos Dunlap');
filterData2('Cincinnati/Football/Clint Boling');
filterData2('Cincinnati/Football/Domata Peko');
filterData2('Cincinnati/Football/Dre Kirkpatrick');
filterData2('Cincinnati/Football/Eric Winston');
filterData2('Cincinnati/Football/Geno Atkins');
filterData2('Cincinnati/Football/Giovani Bernard');
filterData2('Cincinnati/Football/Jeremy Hill');
filterData2('Cincinnati/Football/Kevin Huber');
filterData2('Cincinnati/Football/Marquis Flowers');
filterData2('Cincinnati/Football/Mohamed Sanu');
filterData2('Cincinnati/Football/Pacman Jones');
filterData2('Cincinnati/Football/Rey Maualuga');
filterData2('Cincinnati/Football/Sean Porter');
filterData2('Cincinnati/Football/Tyler Boyd');
filterData2('Cincinnati/Football/Tyler Eifert');
filterData2('Cincinnati/Football/Vontaze Burfict');
filterData2('Cleveland/Baseball/Carlos Carrasco');
filterData2('Cleveland/Baseball/Corey Kluber');
filterData2('Cleveland/Baseball/Danny Salazar');
filterData2('Cleveland/Baseball/Francisco Lindor');
filterData2('Cleveland/Baseball/Jason Kipnis');
filterData2('Cleveland/Baseball/Josh Tomlin');
filterData2('Cleveland/Baseball/Michael Brantley');
filterData2('Cleveland/Baseball/Mike Napoli');
filterData2('Cleveland/Football/Brian Hartline');
filterData2('Cleveland/Football/Cody Kessler');
filterData2('Cleveland/Football/Connor Shaw');
filterData2('Cleveland/Football/Corey Coleman');
filterData2('Cleveland/Football/Danny Shelton');
filterData2('Cleveland/Football/Donte Whitner');
filterData2('Cleveland/Football/Dwayne Bowe');
filterData2('Cleveland/Football/Gary Barnidge');
filterData2('Cleveland/Football/Isaiah Crowell');
filterData2('Cleveland/Football/Joe Haden');
filterData2('Cleveland/Football/Johnny Manziel');
filterData2('Cleveland/Football/Josh Gordon');
filterData2('Cleveland/Football/Josh McCown');
filterData2('Cleveland/Football/Justin Gilbert');
filterData2('Cleveland/Football/Nile Lawerence-Stample');
filterData2('Cleveland/Football/Raheem Mostert');
filterData2('Cleveland/Football/Ricardo Louis');
filterData2('Cleveland/Football/Taylor Gabriel');
filterData2('Cleveland/Football/Travis Benjamin');
filterData2('Colorado/Baseball/Ben Paulsen');
filterData2('Colorado/Baseball/Carlos Gonzalez');
filterData2('Colorado/Baseball/Charlie Blackmon');
filterData2('Colorado/Baseball/DJ LeMahieu');
filterData2('Colorado/Baseball/Jose Reyes');
filterData2('Colorado/Baseball/Nick Hundley');
filterData2('Colorado/Baseball/Nolan Arenado');
filterData2('Colorado/Baseball/Trevor Story');
filterData2('Colorado/Baseball/Tyler Anderson');
filterData2('Colorado/Hockey/Borna Rendulic');
filterData2('Colorado/Hockey/Brad Stuart');
filterData2('Colorado/Hockey/Cody McLeod');
filterData2('Colorado/Hockey/Daniel Briere');
filterData2('Colorado/Hockey/Dennis Everberg');
filterData2('Colorado/Hockey/Erik Johnson');
filterData2('Colorado/Hockey/Freddie Hamilton');
filterData2('Colorado/Hockey/Gabriel Landeskog');
filterData2('Colorado/Hockey/Jan Hejda');
filterData2('Colorado/Hockey/Jarome Iginla');
filterData2('Colorado/Hockey/Jesse Winchester');
filterData2('Colorado/Hockey/Joey Hishon');
filterData2('Colorado/Hockey/John Mitchell');
filterData2('Colorado/Hockey/Jordan Caron');
filterData2('Colorado/Hockey/Matt Ducehne');
filterData2('Colorado/Hockey/Matt Duchene');
filterData2('Colorado/Hockey/Nate Guenin');
filterData2('Colorado/Hockey/Nathan MacKinnon');
filterData2('Colorado/Hockey/Nathan Mackinnon Jarome Iginla');
filterData2('Colorado/Hockey/Nick Holden');
filterData2('Colorado/Hockey/Patrick Bordeleau');
filterData2('Colorado/Hockey/Ryan Wilson');
filterData2('Colorado/Hockey/Semyon Varlamov');
filterData2('Colorado/Hockey/Tyson Barrie');
filterData2('Colorado/Hockey/Zach Redmond');
filterData2('Columbus/Hockey/Alexander Wennberg');
filterData2('Columbus/Hockey/Artem Anisimov');
filterData2('Columbus/Hockey/Boone Jenner');
filterData2('Columbus/Hockey/Cam Atkinson');
filterData2('Columbus/Hockey/Cody Goloubef');
filterData2('Columbus/Hockey/Curtis McElhinney');
filterData2('Columbus/Hockey/Dalton Prout');
filterData2('Columbus/Hockey/David Clarkson');
filterData2('Columbus/Hockey/David Savard');
filterData2('Columbus/Hockey/Fedor Tyutin');
filterData2('Columbus/Hockey/Jack Johnson');
filterData2('Columbus/Hockey/Jack Skille');
filterData2('Columbus/Hockey/Jared Boll');
filterData2('Columbus/Hockey/Justin Falk');
filterData2('Columbus/Hockey/Kevin Connauton');
filterData2('Columbus/Hockey/Marko Dano');
filterData2('Columbus/Hockey/Matt Calvert');
filterData2('Columbus/Hockey/Nick Foligno');
filterData2('Columbus/Hockey/Rene Bourque');
filterData2('Columbus/Hockey/Ryan Johansen');
filterData2('Columbus/Hockey/Ryan Murray');
filterData2('Columbus/Hockey/Scott Hartnell');
filterData2('Columbus/Hockey/Sergei Bobrovsky');
filterData2('Dallas/Football/Barry Church');
filterData2('Dallas/Football/Byron Jones');
filterData2('Dallas/Football/Chaz Green');
filterData2('Dallas/Football/Cole Beasley');
filterData2('Dallas/Football/Dak Prescott');
filterData2('Dallas/Football/Damien Wilson');
filterData2('Dallas/Football/Dan Bailey');
filterData2('Dallas/Football/Darren McFadden');
filterData2('Dallas/Football/Deon King');
filterData2('Dallas/Football/Dez Bryant');
filterData2('Dallas/Football/Ezekiel Elliott');
filterData2('Dallas/Football/Greg Hardy');
filterData2('Dallas/Football/Jason Witten');
filterData2('Dallas/Football/Joseph Randle');
filterData2('Dallas/Football/Nick Hayden');
filterData2('Dallas/Football/Randy Gregory');
filterData2('Dallas/Football/Rolando McClain');
filterData2('Dallas/Football/Ryan Miller');
filterData2('Dallas/Football/Sean Lee');
filterData2('Dallas/Football/Terrance Williams');
filterData2('Dallas/Football/Tony Romo Darren McFadden');
filterData2('Dallas/Football/Tony Romo Dez Bryant');
filterData2('Dallas/Football/Tony Romo Jason Witten');
filterData2('Dallas/Football/Tony Romo Terrance Williams');
filterData2('Dallas/Football/Tony Romo');
filterData2('Dallas/Football/Travis Frederick');
filterData2('Dallas/Football/Tyron Smith');
filterData2('Dallas/Hockey/Ales Hemsky');
filterData2('Dallas/Hockey/Antoine Roussel');
filterData2('Dallas/Hockey/Brett Ritchie');
filterData2('Dallas/Hockey/Cody Eakin');
filterData2('Dallas/Hockey/Colton Sceviour');
filterData2('Dallas/Hockey/Curtis McKenzie');
filterData2('Dallas/Hockey/Jamie Benn');
filterData2('Dallas/Hockey/Jason Demers');
filterData2('Dallas/Hockey/Jason Spezza');
filterData2('Dallas/Hockey/John Klingberg');
filterData2('Dallas/Hockey/Jordie Benn');
filterData2('Dallas/Hockey/Jyrki Jokipakka');
filterData2('Dallas/Hockey/Kari Lehtonen');
filterData2('Dallas/Hockey/Patrick Eaves');
filterData2('Dallas/Hockey/Patrik Nemeth');
filterData2('Dallas/Hockey/Rich Peverley');
filterData2('Dallas/Hockey/Shawn Horcoff');
filterData2('Dallas/Hockey/Travis Moen');
filterData2('Dallas/Hockey/Tyler Seguin');
filterData2('Dallas/Hockey/Valeri Nichushkin');
filterData2('Dallas/Hockey/Vernon Fiddler');
filterData2('Denver/Football/Aqib Talib');
filterData2('Denver/Football/Brandon McManus');
filterData2('Denver/Football/Brock Osweiler');
filterData2('Denver/Football/CJ Anderson');
filterData2('Denver/Football/Chase Vaughn');
filterData2('Denver/Football/Chris Harris Jr');
filterData2('Denver/Football/Chris Harris');
filterData2('Denver/Football/DeMarcus Ware Von Miller');
filterData2('Denver/Football/DeMarcus Ware');
filterData2('Denver/Football/Demarcus Ware');
filterData2('Denver/Football/Demaryius Thomas');
filterData2('Denver/Football/Devontae Booker');
filterData2('Denver/Football/Emmanuel Sanders');
filterData2('Denver/Football/Jeremy Stewart');
filterData2('Denver/Football/Kayvon Webster');
filterData2('Denver/Football/Kyle Williams');
filterData2('Denver/Football/Montee Ball');
filterData2('Denver/Football/Owen Daniels');
filterData2('Denver/Football/Paxton Lynch');
filterData2('Denver/Football/Peyton Manning Emmanuel Sanders');
filterData2('Denver/Football/Peyton Manning');
filterData2('Denver/Football/Ryan Clady');
filterData2('Denver/Football/Shane Ray');
filterData2('Denver/Football/Shelley Smith');
filterData2('Denver/Football/Steven Johnson');
filterData2('Denver/Football/TJ Ward');
filterData2('Denver/Football/Terrell Davis');
filterData2('Denver/Football/Von Miller');
filterData2('Detroit/Baseball/Anibal Sanchez');
filterData2('Detroit/Baseball/Francisco Rodriguez');
filterData2('Detroit/Baseball/Ian Kinsler');
filterData2('Detroit/Baseball/JD Martinez');
filterData2('Detroit/Baseball/Jarrod Saltalamacchia');
filterData2('Detroit/Baseball/Jordan Zimmermann');
filterData2('Detroit/Baseball/Justin Upton');
filterData2('Detroit/Baseball/Justin Verlander');
filterData2('Detroit/Baseball/Miguel Cabrera');
filterData2('Detroit/Baseball/Nick Castellanos');
filterData2('Detroit/Baseball/Victor Martinez');
filterData2('Detroit/Football/Ameer Abdullah');
filterData2('Detroit/Football/Brandon Pettigrew');
filterData2('Detroit/Football/Calvin Johnson');
filterData2('Detroit/Football/Dan Orlovsky');
filterData2('Detroit/Football/Darius Slay');
filterData2('Detroit/Football/Don Carey');
filterData2('Detroit/Football/Glover Quin');
filterData2('Detroit/Football/Golden Tate');
filterData2('Detroit/Football/Haloti Ngata');
filterData2('Detroit/Football/Jay Lee');
filterData2('Detroit/Football/Laken Tomlinson');
filterData2('Detroit/Football/Matt Prater');
filterData2('Detroit/Football/Matt Stafford Calvin Johnson');
filterData2('Detroit/Football/Matt Stafford Golden Tate');
filterData2('Detroit/Football/Matt Stafford');
filterData2('Detroit/Football/Matthew Stafford');
filterData2('Detroit/Football/Stephen Tulloch');
filterData2('Detroit/Football/Taylor Decker');
filterData2('Detroit/Football/Theo Riddick');
filterData2('Detroit/Hockey/Alexey Marchenko');
filterData2('Detroit/Hockey/Brendan Smith');
filterData2('Detroit/Hockey/Daniel Cleary');
filterData2('Detroit/Hockey/Danny DeKeyser');
filterData2('Detroit/Hockey/Darren Helm');
filterData2('Detroit/Hockey/Drew Miller');
filterData2('Detroit/Hockey/Dylan Larkin');
filterData2('Detroit/Hockey/Erik Cole');
filterData2('Detroit/Hockey/Gustav Nyquist');
filterData2('Detroit/Hockey/Henrik Zetterberg');
filterData2('Detroit/Hockey/Jimmy Howard');
filterData2('Detroit/Hockey/Joakim Andersson');
filterData2('Detroit/Hockey/Johan Franzen');
filterData2('Detroit/Hockey/Jonathan Ericsson');
filterData2('Detroit/Hockey/Justin Abdelkader');
filterData2('Detroit/Hockey/Kyle Quincey');
filterData2('Detroit/Hockey/Luke Glendening');
filterData2('Detroit/Hockey/Marek Zidlicky');
filterData2('Detroit/Hockey/Niklas Kronwall');
filterData2('Detroit/Hockey/Pavel Datsyuk Henrik Zetterberg');
filterData2('Detroit/Hockey/Pavel Datsyuk');
filterData2('Detroit/Hockey/Riley Sheahan');
filterData2('Detroit/Hockey/Stephen Weiss');
filterData2('Detroit/Hockey/Tomas Jurco');
filterData2('Detroit/Hockey/Tomas Tatar');
filterData2('Detroit/Hockey/Xavier Ouellet');
filterData2('Edmonton/Hockey/Connor McDavid');
filterData2('Edmonton/Hockey/Jonas Gustavsson');
filterData2('Edmonton/Hockey/Jordan Eberle');
filterData2('Edmonton/Hockey/Ryan Nugent-Hopkins');
filterData2('Edmonton/Hockey/Taylor Hall');
filterData2('Fantasy Life/Fantasy Life/Fantasy Football');
filterData2('Fantasy Life/Fantasy Life/Field Yates');
filterData2('Fantasy Life/Fantasy Life/Matthew Berry');
filterData2('Florida/Hockey/Aaron Ekblad');
filterData2('Florida/Hockey/Aleksander Barkov');
filterData2('Florida/Hockey/Alex Petrovic');
filterData2('Florida/Hockey/Brad Boyes');
filterData2('Florida/Hockey/Brandon Pirri');
filterData2('Florida/Hockey/Brian Campbell');
filterData2('Florida/Hockey/Derek MacKenzie');
filterData2('Florida/Hockey/Dmitry Kulikov');
filterData2('Florida/Hockey/Jaromir Jagr');
filterData2('Florida/Hockey/Jonathan Huberdeau');
filterData2('Florida/Hockey/Jussi Jokinen');
filterData2('Florida/Hockey/Nick Bjugstad');
filterData2('Florida/Hockey/Reto Berra');
filterData2('Florida/Hockey/Roberto Luongo');
filterData2('Florida/Hockey/Sam Brittain');
filterData2('Florida/Hockey/Scottie Upshall');
filterData2('Florida/Hockey/Shawn Thornton');
filterData2('Florida/Hockey/Steven Kampfer');
filterData2('Florida/Hockey/Vincent Trocheck');
filterData2('Florida/Hockey/Willie Mitchell');
filterData2('Green Bay/Football/Aaron Rodgers');
filterData2('Green Bay/Football/BJ Raji');
filterData2('Green Bay/Football/Clay Matthews');
filterData2('Green Bay/Football/Davante Adams');
filterData2('Green Bay/Football/DeVante Parker');
filterData2('Green Bay/Football/Eddie Lacy');
filterData2('Green Bay/Football/James Jones');
filterData2('Green Bay/Football/Joe Thomas');
filterData2('Green Bay/Football/John Crockett');
filterData2('Green Bay/Football/John Kuhn');
filterData2('Green Bay/Football/Jordy Nelson');
filterData2('Green Bay/Football/Julius Peppers');
filterData2('Green Bay/Football/Mason Crosby');
filterData2('Green Bay/Football/Morgan Burnett');
filterData2('Green Bay/Football/Randall Cobb');
filterData2('Green Bay/Football/Richard Rodgers');
filterData2('Green Bay/Football/Trevor Davis');
filterData2('Houston/Baseball/Carlos Correa');
filterData2('Houston/Baseball/Carlos Gomez');
filterData2('Houston/Baseball/Colby Rasmus');
filterData2('Houston/Baseball/Dallas Keuchel');
filterData2('Houston/Baseball/Evan Gattis');
filterData2('Houston/Baseball/George Springer');
filterData2('Houston/Baseball/Jose Altuve');
filterData2('Houston/Baseball/Lance McCullers');
filterData2('Houston/Baseball/Tyler White');
filterData2('Houston/Football/Arian Foster');
filterData2('Houston/Football/Braxton Miller');
filterData2('Houston/Football/Brian Cushing');
filterData2('Houston/Football/Brian Hoyer');
filterData2('Houston/Football/Cecil Shorts III');
filterData2('Houston/Football/DeAndre Hopkins');
filterData2('Houston/Football/JJ Watt Brian Cushing');
filterData2('Houston/Football/JJ Watt');
filterData2('Houston/Football/Jadeveon Clowney');
filterData2('Houston/Football/Jaelen Strong');
filterData2('Houston/Football/Jeoffrey Pagan');
filterData2('Houston/Football/Kareem Jackson');
filterData2('Houston/Football/Kevin Johnson');
filterData2('Houston/Football/Shane Lechler');
filterData2('Houston/Football/Tyler Ervin');
filterData2('Houston/Football/Vince Wilfork');
filterData2('Houston/Football/Will Fuller');
filterData2('Indianapolis/Football/Adam Vinatieri');
filterData2('Indianapolis/Football/Andre Johnson');
filterData2('Indianapolis/Football/Andrew Luck Andre Johnson');
filterData2('Indianapolis/Football/Andrew Luck');
filterData2('Indianapolis/Football/Cam Johnson');
filterData2('Indianapolis/Football/Coby Fleener');
filterData2('Indianapolis/Football/DQwell Jackson');
filterData2('Indianapolis/Football/Frank Gore Andre Johnson');
filterData2('Indianapolis/Football/Frank Gore');
filterData2('Indianapolis/Football/Jerrell Freeman');
filterData2('Indianapolis/Football/Kendall Langford');
filterData2('Indianapolis/Football/Pat McAfee');
filterData2('Indianapolis/Football/Quan Bray');
filterData2('Indianapolis/Football/Robert Mathis');
filterData2('Indianapolis/Football/TJ Green');
filterData2('Indianapolis/Football/TY Hilton Andre Johnson');
filterData2('Indianapolis/Football/TY Hilton');
filterData2('Indianapolis/Football/The Ghost');
filterData2('Indianapolis/Football/Vontae Davis');
filterData2('Jacksonville/Football/Allen Hurns');
filterData2('Jacksonville/Football/Allen Robinson');
filterData2('Jacksonville/Football/Blake Bortles Allen Hurns');
filterData2('Jacksonville/Football/Blake Bortles');
filterData2('Jacksonville/Football/Dante Fowler');
filterData2('Jacksonville/Football/Jalen Ramsey');
filterData2('Jacksonville/Football/Julius Thomas');
filterData2('Jacksonville/Football/Justin Blackmon');
filterData2('Jacksonville/Football/Kasey Redfern');
filterData2('Jacksonville/Football/Luke Joeckel');
filterData2('Jacksonville/Football/Marqise Lee');
filterData2('Jacksonville/Football/Nick Marshall');
filterData2('Jacksonville/Football/Paul Posluszny');
filterData2('Jacksonville/Football/SenDerrick Marks');
filterData2('Jacksonville/Football/TJ Yeldon');
filterData2('Jacksonville/Football/Telvin Smith');
filterData2('Jacksonville/Football/Toby Gerhart');
filterData2('Jacksonville/Football/Tony Washington');
filterData2('Jacksonville/Football/Yannick Ngakoue');
filterData2('Kansas City/Baseball/Alcides Escobar');
filterData2('Kansas City/Baseball/Alex Gordon');
filterData2('Kansas City/Baseball/Edinson Volquez');
filterData2('Kansas City/Baseball/Eric Hosmer');
filterData2('Kansas City/Baseball/Lorenzo Cain');
filterData2('Kansas City/Baseball/Mike Moustakas');
filterData2('Kansas City/Baseball/Salvador Perez');
filterData2('Kansas City/Baseball/Wade Davis');
filterData2('Kansas City/Football/Alex Smith Jamaal Charles');
filterData2('Kansas City/Football/Alex Smith Jeremy Maclin');
filterData2('Kansas City/Football/Alex Smith');
filterData2('Kansas City/Football/Charcandrick West');
filterData2('Kansas City/Football/DeAnthony Thomas');
filterData2('Kansas City/Football/DeMarcus Robinson');
filterData2('Kansas City/Football/Derrick Johnson');
filterData2('Kansas City/Football/Eric Berry');
filterData2('Kansas City/Football/Eric Murray');
filterData2('Kansas City/Football/Jamaal Charles');
filterData2('Kansas City/Football/Jeremy Maclin');
filterData2('Kansas City/Football/Justin Houston Tamba Hali');
filterData2('Kansas City/Football/Justin Houston');
filterData2('Kansas City/Football/Kevin Hogan');
filterData2('Kansas City/Football/Marcus Peters');
filterData2('Kansas City/Football/Tamba Hali');
filterData2('Kansas City/Football/Travis Kelce');
filterData2('Los Angeles/Baseball/Adrian Gonzalez');
filterData2('Los Angeles/Baseball/Albert Pujols');
filterData2('Los Angeles/Baseball/Andrelton Simmons');
filterData2('Los Angeles/Baseball/Carl Crawford');
filterData2('Los Angeles/Baseball/Chase Utley');
filterData2('Los Angeles/Baseball/Clayton Kershaw');
filterData2('Los Angeles/Baseball/Corey Seager');
filterData2('Los Angeles/Baseball/Enrique Hernandez');
filterData2('Los Angeles/Baseball/Garrett Richards');
filterData2('Los Angeles/Baseball/Hector Santiago');
filterData2('Los Angeles/Baseball/Huston Street');
filterData2('Los Angeles/Baseball/Jered Weaver');
filterData2('Los Angeles/Baseball/Joc Pederson');
filterData2('Los Angeles/Baseball/Julio Urias');
filterData2('Los Angeles/Baseball/Justin Turner');
filterData2('Los Angeles/Baseball/Kenta Maeda');
filterData2('Los Angeles/Baseball/Mike Trout');
filterData2('Los Angeles/Baseball/Yasiel Puig');
filterData2('Los Angeles/Basketball/Ryan Kelly');
filterData2('Los Angeles/Football/Aaron Donald');
filterData2('Los Angeles/Football/Alec Ogletree');
filterData2('Los Angeles/Football/Brandon McGee');
filterData2('Los Angeles/Football/Chris Long');
filterData2('Los Angeles/Football/Duke Williams');
filterData2('Los Angeles/Football/Jared Cook');
filterData2('Los Angeles/Football/Jared Goff');
filterData2('Los Angeles/Football/Johnny Hekker');
filterData2('Los Angeles/Football/Kenny Britt');
filterData2('Los Angeles/Football/Michael Brockers');
filterData2('Los Angeles/Football/Nick Foles Brian Quick');
filterData2('Los Angeles/Football/Nick Foles');
filterData2('Los Angeles/Football/Pharoh Cooper');
filterData2('Los Angeles/Football/Robert Quinn');
filterData2('Los Angeles/Football/Rodger Saffold');
filterData2('Los Angeles/Football/Tavon Austin');
filterData2('Los Angeles/Football/Todd Gurley');
filterData2('Los Angeles/Football/Wes Welker');
filterData2('Los Angeles/Football/William Hayes');
filterData2('Los Angeles/Hockey/Alec Martinez');
filterData2('Los Angeles/Hockey/Andrej Sekera');
filterData2('Los Angeles/Hockey/Andy Andreoff');
filterData2('Los Angeles/Hockey/Anze Kopitar');
filterData2('Los Angeles/Hockey/Brayden McNabb');
filterData2('Los Angeles/Hockey/Drew Doughty');
filterData2('Los Angeles/Hockey/Dustin Brown');
filterData2('Los Angeles/Hockey/Dwight King');
filterData2('Los Angeles/Hockey/Jake Muzzin');
filterData2('Los Angeles/Hockey/Jamie McBain');
filterData2('Los Angeles/Hockey/Jarret Stoll');
filterData2('Los Angeles/Hockey/Jeff Carter');
filterData2('Los Angeles/Hockey/Jhonas Enroth');
filterData2('Los Angeles/Hockey/Jonathan Quick');
filterData2('Los Angeles/Hockey/Jordan Nolan');
filterData2('Los Angeles/Hockey/Justin Williams');
filterData2('Los Angeles/Hockey/Kyle Clifford');
filterData2('Los Angeles/Hockey/Marian Gaborik');
filterData2('Los Angeles/Hockey/Matt Greene');
filterData2('Los Angeles/Hockey/Mike Richards');
filterData2('Los Angeles/Hockey/Nick Shore');
filterData2('Los Angeles/Hockey/Robyn Regehr');
filterData2('Los Angeles/Hockey/Tanner Pearson');
filterData2('Los Angeles/Hockey/Trevor Lewis');
filterData2('Los Angeles/Hockey/Tyler Toffoli');
filterData2('MMA/MMA/Amanda Bobby Cooper');
filterData2('MMA/MMA/Fabricio Werdum');
filterData2('MMA/MMA/Frank Mir');
filterData2('MMA/MMA/Julianna Pe?ña');
filterData2('MMA/MMA/Julianna Peña');
filterData2('MMA/MMA/Julianna Pe’±a');
filterData2('Memphis/Basketball/Vince Carter');
filterData2('Miami/Baseball/Chris Johnson');
filterData2('Miami/Baseball/Christian Yelich');
filterData2('Miami/Baseball/Dee Gordon');
filterData2('Miami/Baseball/Giancarlo Stanton');
filterData2('Miami/Baseball/Ichiro Suzuki');
filterData2('Miami/Baseball/Jose Fernandez');
filterData2('Miami/Baseball/Marcell Ozuna');
filterData2('Miami/Baseball/Martin Prado');
filterData2('Miami/Football/Cameron Wake');
filterData2('Miami/Football/Dion Sims');
filterData2('Miami/Football/James Burgess Jr');
filterData2('Miami/Football/Jarvis Landry');
filterData2('Miami/Football/Jermon Bushrod');
filterData2('Miami/Football/Jordan Cameron');
filterData2('Miami/Football/Kenyan Drake');
filterData2('Miami/Football/Knowshon Moreno');
filterData2('Miami/Football/Koa Misi');
filterData2('Miami/Football/Lamar Miller');
filterData2('Miami/Football/Laramy Tunsil');
filterData2('Miami/Football/Leontee Carroo');
filterData2('Miami/Football/Michael Thomas');
filterData2('Miami/Football/Ndamukong Suh');
filterData2('Miami/Football/Ryan Tannehill Rishard Matthews');
filterData2('Miami/Football/Ryan Tannehill');
filterData2('Milwaukee/Baseball/Chris Carter');
filterData2('Milwaukee/Baseball/Jimmy Nelson');
filterData2('Milwaukee/Baseball/Jonathan Lucroy');
filterData2('Milwaukee/Baseball/Jonathan Villar');
filterData2('Milwaukee/Baseball/Matt Garza');
filterData2('Milwaukee/Baseball/Ryan Braun');
filterData2('Milwaukee/Baseball/Taylor Jungmann');
filterData2('Minnesota/Baseball/Brian Dozier');
filterData2('Minnesota/Baseball/Byron Buxton');
filterData2('Minnesota/Baseball/Byung-Ho Park');
filterData2('Minnesota/Baseball/Eddie Rosario');
filterData2('Minnesota/Baseball/Eduardo Escobar');
filterData2('Minnesota/Baseball/Joe Mauer');
filterData2('Minnesota/Baseball/Jose Berrios');
filterData2('Minnesota/Football/Adam Thielen');
filterData2('Minnesota/Football/Adrian Peterson');
filterData2('Minnesota/Football/Anthony Barr');
filterData2('Minnesota/Football/Charles Johnson');
filterData2('Minnesota/Football/Cordarrelle Patterson');
filterData2('Minnesota/Football/Kyle Rudolph');
filterData2('Minnesota/Football/Laquon Treadwell');
filterData2('Minnesota/Football/Mackensie Alexander');
filterData2('Minnesota/Football/Matt Asiata');
filterData2('Minnesota/Football/Moritz Bohringer');
filterData2('Minnesota/Football/Stefon Diggs');
filterData2('Minnesota/Football/Stephon Diggs');
filterData2('Minnesota/Football/Teddy Bridgewater & Cordarrelle Patterson');
filterData2('Minnesota/Football/Teddy Bridgewater Adrian Peterson');
filterData2('Minnesota/Football/Teddy Bridgewater');
filterData2('Minnesota/Football/Trae Waynes');
filterData2('Minnesota/Football/Zach Line');
filterData2('Minnesota/Hockey/Charlie Coyle');
filterData2('Minnesota/Hockey/Christian Folin');
filterData2('Minnesota/Hockey/Darcy Kuemper');
filterData2('Minnesota/Hockey/Devan Dubnyk');
filterData2('Minnesota/Hockey/Erik Haula');
filterData2('Minnesota/Hockey/Jared Spurgeon');
filterData2('Minnesota/Hockey/Jason Pominville');
filterData2('Minnesota/Hockey/Jason Zucker');
filterData2('Minnesota/Hockey/Jonas Brodin');
filterData2('Minnesota/Hockey/Jordan Leopold');
filterData2('Minnesota/Hockey/Jordan Schroeder');
filterData2('Minnesota/Hockey/Josh Harding');
filterData2('Minnesota/Hockey/Justin Fontaine');
filterData2('Minnesota/Hockey/Keith Ballard');
filterData2('Minnesota/Hockey/Kyle Brodziak');
filterData2('Minnesota/Hockey/Marco Scandella');
filterData2('Minnesota/Hockey/Matt Cooke');
filterData2('Minnesota/Hockey/Matt Dumba');
filterData2('Minnesota/Hockey/Mikael Granlund');
filterData2('Minnesota/Hockey/Mikko Koivu Zach Parise');
filterData2('Minnesota/Hockey/Mikko Koivu');
filterData2('Minnesota/Hockey/Nate Prosser');
filterData2('Minnesota/Hockey/Nino Niederreiter');
filterData2('Minnesota/Hockey/Ryan Carter');
filterData2('Minnesota/Hockey/Ryan Suter');
filterData2('Minnesota/Hockey/Sean Bergenheim');
filterData2('Minnesota/Hockey/Thomas Vanek');
filterData2('Minnesota/Hockey/Zach Parise');
filterData2('Montreal/Hockey/Al Montoya');
filterData2('Montreal/Hockey/Alex Galchenyuk');
filterData2('Montreal/Hockey/Alexei Emelin');
filterData2('Montreal/Hockey/Andrei Markov');
filterData2('Montreal/Hockey/Brendan Gallagher');
filterData2('Montreal/Hockey/Brian Flynn');
filterData2('Montreal/Hockey/Carey Price');
filterData2('Montreal/Hockey/Dale Weise');
filterData2('Montreal/Hockey/David Desharnais');
filterData2('Montreal/Hockey/Dustin Tokarski');
filterData2('Montreal/Hockey/Greg Pateryn');
filterData2('Montreal/Hockey/Jacob DeLaRose');
filterData2('Montreal/Hockey/Jeff Petry');
filterData2('Montreal/Hockey/Lars Eller');
filterData2('Montreal/Hockey/Manny Malhotra');
filterData2('Montreal/Hockey/Max Pacioretty');
filterData2('Montreal/Hockey/Mike Weaver');
filterData2('Montreal/Hockey/Nathan Beaulieu');
filterData2('Montreal/Hockey/PK Subban');
filterData2('Montreal/Hockey/Pierre-Alexandre Parenteau');
filterData2('Montreal/Hockey/Sergei Gonchar');
filterData2('Montreal/Hockey/Tom Gilbert');
filterData2('Montreal/Hockey/Tomas Plekanec Max Pacioretty');
filterData2('Montreal/Hockey/Tomas Plekanec');
filterData2('Montreal/Hockey/Torrey Mitchell');
filterData2('Nashville/Hockey/Anton Volchenkov');
filterData2('Nashville/Hockey/Calle Jarnkrok');
filterData2('Nashville/Hockey/Carter Hutton');
filterData2('Nashville/Hockey/Cody Franson');
filterData2('Nashville/Hockey/Colin Wilson');
filterData2('Nashville/Hockey/Craig Smith');
filterData2('Nashville/Hockey/Eric Nystrom');
filterData2('Nashville/Hockey/Filip Forsberg');
filterData2('Nashville/Hockey/Gabriel Bourque');
filterData2('Nashville/Hockey/James Neal');
filterData2('Nashville/Hockey/Matt Cullen');
filterData2('Nashville/Hockey/Mattias Ekholm');
filterData2('Nashville/Hockey/Mike Fisher');
filterData2('Nashville/Hockey/Mike Ribeiro James Neal');
filterData2('Nashville/Hockey/Mike Ribeiro');
filterData2('Nashville/Hockey/Paul Gaustad');
filterData2('Nashville/Hockey/Pekka Rinne');
filterData2('Nashville/Hockey/Roman Josi');
filterData2('Nashville/Hockey/Ryan Ellis');
filterData2('Nashville/Hockey/Seth Jones');
filterData2('Nashville/Hockey/Shea Weber');
filterData2('Nashville/Hockey/Victor Bartley');
filterData2('Nashville/Hockey/Viktor Stalberg');
filterData2('New England/Football/Danny Amendola');
filterData2('New England/Football/Darrelle Revis');
filterData2('New England/Football/Dion Lewis');
filterData2('New England/Football/James White');
filterData2('New England/Football/Jerod Mayo');
filterData2('New England/Football/Jimmy Garoppolo');
filterData2('New England/Football/Julian Edelman');
filterData2('New England/Football/Malcolm Butler');
filterData2('New England/Football/Malcolm Mitchell');
filterData2('New England/Football/Martellus Bennett');
filterData2('New England/Football/Patrick Chung');
filterData2('New England/Football/Rob Gronkowski');
filterData2('New England/Football/Rob Ninkovich');
filterData2('New England/Football/Scott Chandler');
filterData2('New England/Football/Stephen Gostkowski');
filterData2('New England/Football/Tom Brady Rob Gronkowski');
filterData2('New England/Football/Tom Brady');
filterData2('New England/Football/Tom Newton Rob Best Olsen');
filterData2('New Jersey/Hockey/Adam Henrique');
filterData2('New Jersey/Hockey/Adam Larsson');
filterData2('New Jersey/Hockey/Bryce Salvador');
filterData2('New Jersey/Hockey/Cory Schneider');
filterData2('New Jersey/Hockey/Dainius Zubrus');
filterData2('New Jersey/Hockey/Jacob Josefson');
filterData2('New Jersey/Hockey/Jon Merrill');
filterData2('New Jersey/Hockey/Jordin Tootoo');
filterData2('New Jersey/Hockey/Keith Kinkaid');
filterData2('New Jersey/Hockey/Mark Fraser');
filterData2('New Jersey/Hockey/Martin Havlat');
filterData2('New Jersey/Hockey/Michael Ryder');
filterData2('New Jersey/Hockey/Mike Cammalleri');
filterData2('New Jersey/Hockey/Patrik Elias');
filterData2('New Jersey/Hockey/Peter Harrold');
filterData2('New Jersey/Hockey/Ryane Clowe');
filterData2('New Jersey/Hockey/Scott Gomez');
filterData2('New Jersey/Hockey/Stephen Gionta');
filterData2('New Jersey/Hockey/Steve Bernier');
filterData2('New Jersey/Hockey/Travis Zajac');
filterData2('New Jersey/Hockey/Tuomo Ruutu');
filterData2('New Orleans/Football/Andrus Peat');
filterData2('New Orleans/Football/Benjamin Watson');
filterData2('New Orleans/Football/Brandin Cooks');
filterData2('New Orleans/Football/Brandon Browner');
filterData2('New Orleans/Football/CJ Spiller');
filterData2('New Orleans/Football/Dannell Ellerbe');
filterData2('New Orleans/Football/Delvin Breaux');
filterData2('New Orleans/Football/Drew Brees');
filterData2('New Orleans/Football/Jahri Evans');
filterData2('New Orleans/Football/Jairus Byrd');
filterData2('New Orleans/Football/Joe Morgan');
filterData2('New Orleans/Football/Jordan Williams-Lambert');
filterData2('New Orleans/Football/Kyle Wilson');
filterData2('New Orleans/Football/Mark Ingram');
filterData2('New Orleans/Football/Marques Colston');
filterData2('New Orleans/Football/Sheldon Rankins');
filterData2('New Orleans/Football/Vinnie Sunseri');
filterData2('New York/Baseball/Alex Rodriguez');
filterData2('New York/Baseball/Andrew Miller');
filterData2('New York/Baseball/Aroldis Chapman');
filterData2('New York/Baseball/Bartolo Colon');
filterData2('New York/Baseball/Brian McCann');
filterData2('New York/Baseball/CC Sabathia');
filterData2('New York/Baseball/Carlos Beltran');
filterData2('New York/Baseball/Curtis Granderson');
filterData2('New York/Baseball/David Wright');
filterData2('New York/Baseball/Didi Gregorious');
filterData2('New York/Baseball/Jacob deGrom');
filterData2('New York/Baseball/Jacoby Ellsbury');
filterData2('New York/Baseball/Luis Severino');
filterData2('New York/Baseball/Mark Teixiera');
filterData2('New York/Baseball/Masahiro Tanaka');
filterData2('New York/Baseball/Matt Harvey');
filterData2('New York/Baseball/Michael Conforto');
filterData2('New York/Baseball/Neil Walker');
filterData2('New York/Baseball/Noah Syndergaard');
filterData2('New York/Baseball/Starlin Castro');
filterData2('New York/Baseball/Steven Matz');
filterData2('New York/Baseball/Travis dArnaud');
filterData2('New York/Baseball/Yoenis Cespedes');
filterData2('New York/Basketball/Courtney Lee');
filterData2('New York/Football/Antonio Cromartie');
filterData2('New York/Football/Brandon Marshall');
filterData2('New York/Football/Chris Ivory');
filterData2('New York/Football/Christian Hackenberg');
filterData2('New York/Football/Darron Lee');
filterData2('New York/Football/Devin Smith');
filterData2('New York/Football/Dominique Rodgers Cromartie');
filterData2('New York/Football/Dominique Rodgers-Cromartie');
filterData2('New York/Football/Eli Apple');
filterData2('New York/Football/Eli Manning Odell Beckham Jr');
filterData2('New York/Football/Eli Manning');
filterData2('New York/Football/Ereck Flowers');
filterData2('New York/Football/Eric Decker');
filterData2('New York/Football/Geno Smith');
filterData2('New York/Football/Jaiquawn Jarrett');
filterData2('New York/Football/Jason Pierre-Paul');
filterData2('New York/Football/Josh Brown');
filterData2('New York/Football/Larry Donnell');
filterData2('New York/Football/Leonard Williams');
filterData2('New York/Football/Marcus Williams');
filterData2('New York/Football/Marshall Newhouse');
filterData2('New York/Football/Matt Forte');
filterData2('New York/Football/Muhammad Wilkerson');
filterData2('New York/Football/Nick Folk');
filterData2('New York/Football/Nick Mangold');
filterData2('New York/Football/Odell Beckham Jr');
filterData2('New York/Football/Paul Perkins');
filterData2('New York/Football/Rashad Jennings');
filterData2('New York/Football/Ryan Fitzpatrick');
filterData2('New York/Football/Sheldon Richardson');
filterData2('New York/Football/Sterling Shepard');
filterData2('New York/Football/Victor Cruz');
filterData2('New York/Football/Zac Stacy');
filterData2('New York/Hockey/Anders Lee');
filterData2('New York/Hockey/Anthony Duclair');
filterData2('New York/Hockey/Brian Strait');
filterData2('New York/Hockey/Brock Nelson');
filterData2('New York/Hockey/Cal Clutterbuck');
filterData2('New York/Hockey/Calvin De Haan');
filterData2('New York/Hockey/Casey Cizikas');
filterData2('New York/Hockey/Chris Kreider');
filterData2('New York/Hockey/Colin McDonald');
filterData2('New York/Hockey/Dan Boyle');
filterData2('New York/Hockey/Dan Girardi');
filterData2('New York/Hockey/Daniel Girardi');
filterData2('New York/Hockey/Derek Stepan');
filterData2('New York/Hockey/Derick Brassard');
filterData2('New York/Hockey/Dominic Moore');
filterData2('New York/Hockey/Eric Boulton');
filterData2('New York/Hockey/Frans Nielsen');
filterData2('New York/Hockey/Henrik Lundqvist');
filterData2('New York/Hockey/JT Miller');
filterData2('New York/Hockey/James Sheppard');
filterData2('New York/Hockey/Jaroslav Halak');
filterData2('New York/Hockey/Jesper Fast');
filterData2('New York/Hockey/John Tavares');
filterData2('New York/Hockey/Johnny Boychuk');
filterData2('New York/Hockey/Josh Bailey');
filterData2('New York/Hockey/Kael Mouillierat');
filterData2('New York/Hockey/Kevin Hayes');
filterData2('New York/Hockey/Kevin Klein');
filterData2('New York/Hockey/Kyle Okposo');
filterData2('New York/Hockey/Lubomir Visnovsky');
filterData2('New York/Hockey/Luke John');
filterData2('New York/Hockey/Mackenzie Skapski');
filterData2('New York/Hockey/Marc Staal');
filterData2('New York/Hockey/Martin St Louis');
filterData2('New York/Hockey/Mats Zuccarello');
filterData2('New York/Hockey/Matt Donovan');
filterData2('New York/Hockey/Matt Hunwick');
filterData2('New York/Hockey/Matt Martin');
filterData2('New York/Hockey/Mikhail Grabovski');
filterData2('New York/Hockey/Nick Leddy');
filterData2('New York/Hockey/Nikolay Kulemin');
filterData2('New York/Hockey/Rick Nash Martin St Louis');
filterData2('New York/Hockey/Rick Nash');
filterData2('New York/Hockey/Ryan McDonagh');
filterData2('New York/Hockey/Ryan Strome');
filterData2('New York/Hockey/Tanner Glass');
filterData2('New York/Hockey/Thomas Greiss');
filterData2('New York/Hockey/Thomas Hickey');
filterData2('New York/Hockey/Travis Hamonic');
filterData2('New York/Hockey/Tyler Kennedy');
filterData2('Oakland/Baseball/Billy Burns');
filterData2('Oakland/Baseball/Billy Butler');
filterData2('Oakland/Baseball/Coco Crisp');
filterData2('Oakland/Baseball/Khris Davis');
filterData2('Oakland/Baseball/Rich Hill');
filterData2('Oakland/Baseball/Sonny Gray');
filterData2('Oakland/Baseball/Stephen Vogt');
filterData2('Oakland/Football/Amari Cooper');
filterData2('Oakland/Football/Charles Woodson');
filterData2('Oakland/Football/Connor Cook');
filterData2('Oakland/Football/Dan Williams');
filterData2('Oakland/Football/DeAndre Washington');
filterData2('Oakland/Football/Derek Carr Amari Cooper');
filterData2('Oakland/Football/Derek Carr');
filterData2('Oakland/Football/Justin Tuck');
filterData2('Oakland/Football/Karl Joseph');
filterData2('Oakland/Football/Khalil Mack');
filterData2('Oakland/Football/Latavius Murray');
filterData2('Oakland/Football/Malcolm Smith');
filterData2('Oakland/Football/Marquette King');
filterData2('Oakland/Football/Michael Crabtree');
filterData2('Oakland/Football/Neiron Ball');
filterData2('Oakland/Football/Sebastian Janikowski');
filterData2('Ottawa/Hockey/Alex Chiasson');
filterData2('Ottawa/Hockey/Andrew Hammond');
filterData2('Ottawa/Hockey/Bobby Ryan');
filterData2('Ottawa/Hockey/Chris Neil');
filterData2('Ottawa/Hockey/Chris Phillips');
filterData2('Ottawa/Hockey/Clarke MacArthur Bobby Ryan');
filterData2('Ottawa/Hockey/Cody Ceci');
filterData2('Ottawa/Hockey/Craig Anderson');
filterData2('Ottawa/Hockey/Curtis Lazar');
filterData2('Ottawa/Hockey/Erik Condra');
filterData2('Ottawa/Hockey/Erik Karlsson');
filterData2('Ottawa/Hockey/Jean-Gabriel Pageau');
filterData2('Ottawa/Hockey/Kyle Turris');
filterData2('Ottawa/Hockey/Marc Methot');
filterData2('Ottawa/Hockey/Mark Borowiecki');
filterData2('Ottawa/Hockey/Mark Stone');
filterData2('Ottawa/Hockey/Matt Puempel');
filterData2('Ottawa/Hockey/Mika Zibanejad');
filterData2('Ottawa/Hockey/Mike Hoffman');
filterData2('Ottawa/Hockey/Patrick Wiercioch');
filterData2('Ottawa/Hockey/Zack Smith');
filterData2('Philadelphia/Baseball/Aaron Nola');
filterData2('Philadelphia/Baseball/Freddy Galvis');
filterData2('Philadelphia/Baseball/Maikel Franco');
filterData2('Philadelphia/Baseball/Odubel Herrera');
filterData2('Philadelphia/Baseball/Peter Bourjos');
filterData2('Philadelphia/Baseball/Ryan Howard');
filterData2('Philadelphia/Baseball/Vincent Velasquez');
filterData2('Philadelphia/Football/Bennie Logan');
filterData2('Philadelphia/Football/Brent Celek');
filterData2('Philadelphia/Football/Carson Wentz');
filterData2('Philadelphia/Football/Cody Parkey');
filterData2('Philadelphia/Football/Connor Barwin');
filterData2('Philadelphia/Football/Darrell Greene');
filterData2('Philadelphia/Football/Darren Sproles');
filterData2('Philadelphia/Football/DeMarco Murray');
filterData2('Philadelphia/Football/Jason Peters');
filterData2('Philadelphia/Football/Jordan Hicks');
filterData2('Philadelphia/Football/Kiko Alonso');
filterData2('Philadelphia/Football/Lane Johnson');
filterData2('Philadelphia/Football/Miles Austin');
filterData2('Philadelphia/Football/Nelson Agholor');
filterData2('Philadelphia/Football/Riley Cooper');
filterData2('Philadelphia/Football/Ryan Mathews');
filterData2('Philadelphia/Football/Sam Bradford Darren Sproles');
filterData2('Philadelphia/Football/Sam Bradford Ryan Matthews');
filterData2('Philadelphia/Football/Sam Bradford Zach Ertz');
filterData2('Philadelphia/Football/Sam Bradford');
filterData2('Philadelphia/Football/Tim Tebow');
filterData2('Philadelphia/Football/Wendall Smallwood');
filterData2('Philadelphia/Football/Wendell Smallwood');
filterData2('Philadelphia/Football/Zach Ertz Play');
filterData2('Philadelphia/Football/Zach Ertz');
filterData2('Philadelphia/Hockey/Andrew MacDonald');
filterData2('Philadelphia/Hockey/Brandon Manning');
filterData2('Philadelphia/Hockey/Brayden Schenn');
filterData2('Philadelphia/Hockey/Carlo Colaiacovo');
filterData2('Philadelphia/Hockey/Chris VandeVelde');
filterData2('Philadelphia/Hockey/Claude Giroux Jakub Voracek');
filterData2('Philadelphia/Hockey/Claude Giroux');
filterData2('Philadelphia/Hockey/Jakub Voracek');
filterData2('Philadelphia/Hockey/Luke Schenn');
filterData2('Philadelphia/Hockey/Mark Streit');
filterData2('Philadelphia/Hockey/Matt Read');
filterData2('Philadelphia/Hockey/Michael Del Zotto');
filterData2('Philadelphia/Hockey/Michael Raffl');
filterData2('Philadelphia/Hockey/Michal Neuvirth');
filterData2('Philadelphia/Hockey/Nick Cousins');
filterData2('Philadelphia/Hockey/Nick Schultz');
filterData2('Philadelphia/Hockey/Nicklas Grossmann');
filterData2('Philadelphia/Hockey/Pierre-Edouard Bellemare');
filterData2('Philadelphia/Hockey/RJ Umberger');
filterData2('Philadelphia/Hockey/Ryan White');
filterData2('Philadelphia/Hockey/Sean Couturier');
filterData2('Philadelphia/Hockey/Shayne Gostisbehere');
filterData2('Philadelphia/Hockey/Steve Mason');
filterData2('Philadelphia/Hockey/Vincent Lecavalier');
filterData2('Philadelphia/Hockey/Wayne Simmonds');
filterData2('Philadelphia/Hockey/Zac Rinaldo');
filterData2('Pittsburgh/Baseball/Andrew McCutchen');
filterData2('Pittsburgh/Baseball/Chris Stewart');
filterData2('Pittsburgh/Baseball/Francisco Cervelli');
filterData2('Pittsburgh/Baseball/Francisco Liriano');
filterData2('Pittsburgh/Baseball/Gerrit Cole');
filterData2('Pittsburgh/Baseball/Gerritt Cole');
filterData2('Pittsburgh/Baseball/Gregory Polanco');
filterData2('Pittsburgh/Baseball/Josh Harrison');
filterData2('Pittsburgh/Baseball/Starling Marte Font K');
filterData2('Pittsburgh/Baseball/Starling Marte');
filterData2('Pittsburgh/Football/Alvin Dupree');
filterData2('Pittsburgh/Football/Antonio Brown');
filterData2('Pittsburgh/Football/Ben Roethlisberger Antonio Brown');
filterData2('Pittsburgh/Football/Ben Roethlisberger');
filterData2('Pittsburgh/Football/Bud Dupree');
filterData2('Pittsburgh/Football/DeAngelo Williams');
filterData2('Pittsburgh/Football/Heath Miller');
filterData2('Pittsburgh/Football/James Harrison');
filterData2('Pittsburgh/Football/LeVeon Bell');
filterData2('Pittsburgh/Football/Markus Wheaton');
filterData2('Pittsburgh/Football/Martavis Bryant');
filterData2('Pittsburgh/Football/Matt Murray');
filterData2('Pittsburgh/Football/Mike Vick');
filterData2('Pittsburgh/Hockey/Andrew Ebbett');
filterData2('Pittsburgh/Hockey/Beau Bennett');
filterData2('Pittsburgh/Hockey/Bryan Rust');
filterData2('Pittsburgh/Hockey/Chris Kunitz');
filterData2('Pittsburgh/Hockey/Craig Adams');
filterData2('Pittsburgh/Hockey/David Perron');
filterData2('Pittsburgh/Hockey/Evgeni Malkin');
filterData2('Pittsburgh/Hockey/Ian Cole');
filterData2('Pittsburgh/Hockey/Kris LeTang');
filterData2('Pittsburgh/Hockey/Kris Letang');
filterData2('Pittsburgh/Hockey/Marc-Andre Fleury');
filterData2('Pittsburgh/Hockey/Maxim Lapierre');
filterData2('Pittsburgh/Hockey/Olli Maatta');
filterData2('Pittsburgh/Hockey/Pascal Dupuis');
filterData2('Pittsburgh/Hockey/Patric Hornqvist');
filterData2('Pittsburgh/Hockey/Paul Martin');
filterData2('Pittsburgh/Hockey/Sidney Crosby Evgeni Malkin');
filterData2('Pittsburgh/Hockey/Sidney Crosby');
filterData2('Pittsburgh/Hockey/Steve Downie');
filterData2('San Diego/Baseball/Alexei Ramirez');
filterData2('San Diego/Baseball/Andrew Cashner');
filterData2('San Diego/Baseball/Matt Kemp');
filterData2('San Diego/Baseball/Tyson Ross');
filterData2('San Diego/Baseball/Wil Myers');
filterData2('San Diego/Football/Antonio Gates');
filterData2('San Diego/Football/Chris Davis');
filterData2('San Diego/Football/Danny Woodhead');
filterData2('San Diego/Football/Darrell Stuckey');
filterData2('San Diego/Football/David Johnson');
filterData2('San Diego/Football/Eric Weddle');
filterData2('San Diego/Football/Hunter Henry');
filterData2('San Diego/Football/Jacoby Jones');
filterData2('San Diego/Football/Jason Verrett');
filterData2('San Diego/Football/Joey Bosa');
filterData2('San Diego/Football/Josh Lambo');
filterData2('San Diego/Football/Keenan Allen');
filterData2('San Diego/Football/Kenny Wiggins');
filterData2('San Diego/Football/Kyle Emanuel');
filterData2('San Diego/Football/Manti Teo');
filterData2('San Diego/Football/Melvin Gordon');
filterData2('San Diego/Football/Mike Scifres');
filterData2('San Diego/Football/Mike Windt');
filterData2('San Diego/Football/Nick Dzubnar');
filterData2('San Diego/Football/Philip Rivers Antonio Gates');
filterData2('San Diego/Football/Philip Rivers Keenan Allen');
filterData2('San Diego/Football/Philip Rivers Malcom Floyd');
filterData2('San Diego/Football/Philip Rivers');
filterData2('San Diego/Football/Sean Lissemore');
filterData2('San Diego/Football/Sean McGrath');
filterData2('San Diego/Football/Tourek Williams');
filterData2('San Francisco/Baseball/Brandon Crawford');
filterData2('San Francisco/Baseball/Buster Posey');
filterData2('San Francisco/Baseball/Denard Span');
filterData2('San Francisco/Baseball/George Kontos');
filterData2('San Francisco/Baseball/Hunter Pence');
filterData2('San Francisco/Baseball/Jeff Samardzija');
filterData2('San Francisco/Baseball/Johnny Cueto');
filterData2('San Francisco/Baseball/Madison Bumgarner');
filterData2('San Francisco/Football/Aldon Smith');
filterData2('San Francisco/Football/Andy Lee');
filterData2('San Francisco/Football/Anquan Boldin');
filterData2('San Francisco/Football/Antoine Bethea');
filterData2('San Francisco/Football/Asante Cleveland');
filterData2('San Francisco/Football/Bruce Ellington');
filterData2('San Francisco/Football/Bruce Miller');
filterData2('San Francisco/Football/Carlos Hyde');
filterData2('San Francisco/Football/Colin Kaepernick Anquan Boldin');
filterData2('San Francisco/Football/Colin Kaepernick');
filterData2('San Francisco/Football/DeForest Buckner');
filterData2('San Francisco/Football/Derek Carrier');
filterData2('San Francisco/Football/Garrett Celek');
filterData2('San Francisco/Football/Jarryd Hayne');
filterData2('San Francisco/Football/Justin Smith');
filterData2('San Francisco/Football/Kendall Hunter');
filterData2('San Francisco/Football/Marcus Cromartie');
filterData2('San Francisco/Football/Mike Davis');
filterData2('San Francisco/Football/NaVorro Bowman');
filterData2('San Francisco/Football/Reggie Bush');
filterData2('San Francisco/Football/Vance McDonald');
filterData2('San Francisco/Football/Vernon Davis');
filterData2('San Jose/Hockey/Brent Burns');
filterData2('San Jose/Hockey/Joe Pavelski');
filterData2('San Jose/Hockey/Joe Thornton Joe Pavelski');
filterData2('San Jose/Hockey/Joe Thornton');
filterData2('San Jose/Hockey/Logan Couture');
filterData2('San Jose/Hockey/Marc-Edouard Vlasic');
filterData2('San Jose/Hockey/Martin Jones');
filterData2('San Jose/Hockey/Patrick Marleau');
filterData2('Seattle/Baseball/Adam Lind');
filterData2('Seattle/Baseball/Felix Hernandez');
filterData2('Seattle/Baseball/Hisashi Iwakuma');
filterData2('Seattle/Baseball/Kyle Seager');
filterData2('Seattle/Baseball/Nelson Cruz');
filterData2('Seattle/Baseball/Nori Aoki');
filterData2('Seattle/Baseball/Robinson Cano');
filterData2('Seattle/Baseball/Taijuan Walker');
filterData2('Seattle/Football/AJ Prosise');
filterData2('Seattle/Football/Alex Collins');
filterData2('Seattle/Football/Bobby Wagner');
filterData2('Seattle/Football/Brandon Mebane');
filterData2('Seattle/Football/Brock Coyle');
filterData2('Seattle/Football/Bruce Irvin');
filterData2('Seattle/Football/CJ Prosise');
filterData2('Seattle/Football/Cliff Avril');
filterData2('Seattle/Football/Clint Gresham');
filterData2('Seattle/Football/DeShawn Shead');
filterData2('Seattle/Football/Doug Baldwin');
filterData2('Seattle/Football/Earl Thomas');
filterData2('Seattle/Football/George Fant');
filterData2('Seattle/Football/JR Sweezy');
filterData2('Seattle/Football/Jeremy Lane');
filterData2('Seattle/Football/Jermaine Kearse');
filterData2('Seattle/Football/Jimmy Graham');
filterData2('Seattle/Football/Jon Ryan');
filterData2('Seattle/Football/KJ Wright');
filterData2('Seattle/Football/Kam Chancellor');
filterData2('Seattle/Football/Luke Willson');
filterData2('Seattle/Football/Marshawn Lynch');
filterData2('Seattle/Football/Michael Bennett');
filterData2('Seattle/Football/Richard Sherman Kam Chancellor');
filterData2('Seattle/Football/Richard Sherman');
filterData2('Seattle/Football/Russell Wilson');
filterData2('Seattle/Football/Seattle Skyline');
filterData2('Seattle/Football/Steven Hauschka');
filterData2('Seattle/Football/Thomas Rawls');
filterData2('Seattle/Football/Tyler Lockett');
filterData2('Seattle/Football/Wilson Newton Lynch Best Olsen');
filterData2('Seattle/Football/Wilson Newton Lynch Olsen');
filterData2('St. Louis/Baseball/Adam Wainwright');
filterData2('St. Louis/Baseball/Aledmys Diaz');
filterData2('St. Louis/Baseball/Jhonny Peralta');
filterData2('St. Louis/Baseball/Kolten Wong');
filterData2('St. Louis/Baseball/Matt Carpenter');
filterData2('St. Louis/Baseball/Matt Holliday');
filterData2('St. Louis/Baseball/Michael Wacha');
filterData2('St. Louis/Baseball/Stephen Piscotty');
filterData2('St. Louis/Baseball/Yadier Molina');
filterData2('St. Louis/Hockey/Alex Pietrangelo');
filterData2('St. Louis/Hockey/Alexander Steen');
filterData2('St. Louis/Hockey/Barret Jackman');
filterData2('St. Louis/Hockey/Brian Elliott');
filterData2('St. Louis/Hockey/Carl Gunnarsson');
filterData2('St. Louis/Hockey/Chris Butler');
filterData2('St. Louis/Hockey/Chris Porter');
filterData2('St. Louis/Hockey/David Backes');
filterData2('St. Louis/Hockey/Dmitrij Jaskin');
filterData2('St. Louis/Hockey/Jaden Schwartz');
filterData2('St. Louis/Hockey/Jake Allen');
filterData2('St. Louis/Hockey/Jay Bouwmeester');
filterData2('St. Louis/Hockey/Jori Lehtera');
filterData2('St. Louis/Hockey/Kevin Shattenkirk');
filterData2('St. Louis/Hockey/Marcel Goc');
filterData2('St. Louis/Hockey/Olli Jokinen');
filterData2('St. Louis/Hockey/Patrik Berglund');
filterData2('St. Louis/Hockey/Paul Stastny');
filterData2('St. Louis/Hockey/Petteri Lindbohm');
filterData2('St. Louis/Hockey/Robert Bortuzzo');
filterData2('St. Louis/Hockey/Ryan Reaves');
filterData2('St. Louis/Hockey/Steve Ott');
filterData2('St. Louis/Hockey/TJ Oshie');
filterData2('St. Louis/Hockey/Vladimir Tarasenko');
filterData2('St. Louis/Hockey/Zbynek Michalek');
filterData2('Tampa Bay/Baseball/Chris Archer');
filterData2('Tampa Bay/Baseball/Desmond Jennings');
filterData2('Tampa Bay/Baseball/Drew Smyly');
filterData2('Tampa Bay/Baseball/Evan Longoria');
filterData2('Tampa Bay/Baseball/Jake Odorizzi');
filterData2('Tampa Bay/Baseball/Kevin Kiermaier');
filterData2('Tampa Bay/Baseball/Logan Forsythe');
filterData2('Tampa Bay/Baseball/Matt Moore');
filterData2('Tampa Bay/Baseball/Steven Souza Jr');
filterData2('Tampa Bay/Football/CJ Wilson');
filterData2('Tampa Bay/Football/Chris Hackett');
filterData2('Tampa Bay/Football/Doug Martin');
filterData2('Tampa Bay/Football/Gerald McCoy');
filterData2('Tampa Bay/Football/Jameis Winston Mike Evans');
filterData2('Tampa Bay/Football/Jameis Winston Vincent Jackson');
filterData2('Tampa Bay/Football/Jameis Winston');
filterData2('Tampa Bay/Football/Keith Tandy');
filterData2('Tampa Bay/Football/Kwon Alexander');
filterData2('Tampa Bay/Football/Lavonte David');
filterData2('Tampa Bay/Football/Louis Murphy');
filterData2('Tampa Bay/Football/Mike Evans');
filterData2('Tampa Bay/Football/Vernon Hargreaves III');
filterData2('Tampa Bay/Football/Vincent Jackson');
filterData2('Tampa Bay/Hockey/Alex Killorn');
filterData2('Tampa Bay/Hockey/Andrei Vasilevskiy');
filterData2('Tampa Bay/Hockey/Andrej Sustr');
filterData2('Tampa Bay/Hockey/Anton Stralman');
filterData2('Tampa Bay/Hockey/Ben Bishop');
filterData2('Tampa Bay/Hockey/Braydon Coburn');
filterData2('Tampa Bay/Hockey/Brenden Morrow');
filterData2('Tampa Bay/Hockey/Brian Boyle');
filterData2('Tampa Bay/Hockey/Cedric Paquette');
filterData2('Tampa Bay/Hockey/JT Brown');
filterData2('Tampa Bay/Hockey/Jason Garrison');
filterData2('Tampa Bay/Hockey/Jonathan Drouin');
filterData2('Tampa Bay/Hockey/Mark Barberio');
filterData2('Tampa Bay/Hockey/Matthew Carle');
filterData2('Tampa Bay/Hockey/Mike Angelidis');
filterData2('Tampa Bay/Hockey/Nikita Kucherov');
filterData2('Tampa Bay/Hockey/Nikita Nesterov');
filterData2('Tampa Bay/Hockey/Ondrej Palat');
filterData2('Tampa Bay/Hockey/Radko Gudas');
filterData2('Tampa Bay/Hockey/Ryan Callahan');
filterData2('Tampa Bay/Hockey/Steven Stamkos Ryan Callahan');
filterData2('Tampa Bay/Hockey/Steven Stamkos');
filterData2('Tampa Bay/Hockey/Tyler Johnson');
filterData2('Tampa Bay/Hockey/Valterri Filppula');
filterData2('Tampa Bay/Hockey/Valterri Flippula');
filterData2('Tampa Bay/Hockey/Valtteri Filppula');
filterData2('Tampa Bay/Hockey/Victor Hedman');
filterData2('Tampa Bay/Hockey/Vladislav Namestnikov');
filterData2('Tennessee/Football/Bishop Sankey');
filterData2('Tennessee/Football/Brian Orakpo');
filterData2('Tennessee/Football/DaNorris Searcy');
filterData2('Tennessee/Football/David Cobb');
filterData2('Tennessee/Football/Delanie Walker');
filterData2('Tennessee/Football/Derrick Henry');
filterData2('Tennessee/Football/Dexter McCluster');
filterData2('Tennessee/Football/Jack Conklin');
filterData2('Tennessee/Football/Kendall Wright');
filterData2('Tennessee/Football/Marcus Mariota');
filterData2('Texas/Baseball/Adrian Beltre');
filterData2('Texas/Baseball/Cole Hamels');
filterData2('Texas/Baseball/Elvis Andrus');
filterData2('Texas/Baseball/Ian Desmond');
filterData2('Texas/Baseball/Nomar Mazara');
filterData2('Texas/Baseball/Prince Fielder');
filterData2('Texas/Baseball/Yu Darvish');
filterData2('Throwbacks/Throwbacks/Andre Dawson');
filterData2('Throwbacks/Throwbacks/Bernie Parent');
filterData2('Throwbacks/Throwbacks/Brian Bosworth');
filterData2('Throwbacks/Throwbacks/Bruce Lee');
filterData2('Throwbacks/Throwbacks/Clinton Portis');
filterData2('Throwbacks/Throwbacks/Dwight Gooden');
filterData2('Throwbacks/Throwbacks/Eric Dickerson');
filterData2('Throwbacks/Throwbacks/Gary Payton');
filterData2('Throwbacks/Throwbacks/Isaac Bruce');
filterData2('Throwbacks/Throwbacks/Joe Greene');
filterData2('Throwbacks/Throwbacks/Ladainian Tomlinson');
filterData2('Throwbacks/Throwbacks/Martin Brodeur');
filterData2('Throwbacks/Throwbacks/Olie Kolzig');
filterData2('Throwbacks/Throwbacks/Patrick Willis');
filterData2('Throwbacks/Throwbacks/Pavel Bure');
filterData2('Throwbacks/Throwbacks/Ray Lewis');
filterData2('Throwbacks/Throwbacks/Rick Mahorn');
filterData2('Throwbacks/Throwbacks/Ron Santo');
filterData2('Throwbacks/Throwbacks/Shawn Marion');
filterData2('Throwbacks/Throwbacks/Spud Webb');
filterData2('Throwbacks/Throwbacks/Steve Largent');
filterData2('Throwbacks/Throwbacks/Terrell Owens');
filterData2('Throwbacks/Throwbacks/Troy Polamalu');
filterData2('Throwbacks/Throwbacks/Walkter Peyton');
filterData2('Throwbacks/Throwbacks/Walter Payton');
filterData2('Throwbacks/Throwbacks/Warren Sapp');
filterData2('Throwbacks/Throwbacks/Wayne Chrebet');
filterData2('Toronto/Baseball/Edwin Encarnacion');
filterData2('Toronto/Baseball/Jose Bautista');
filterData2('Toronto/Baseball/Josh Donaldson');
filterData2('Toronto/Baseball/Marco Estrada');
filterData2('Toronto/Baseball/Marcus Stroman');
filterData2('Toronto/Baseball/RA Dickey');
filterData2('Toronto/Baseball/Russell Martin');
filterData2('Toronto/Baseball/Troy Tulowitzki');
filterData2('Toronto/Hockey/Dion Phaneuf');
filterData2('Toronto/Hockey/James Van Riemsdyk');
filterData2('Toronto/Hockey/Joffrey Lupul');
filterData2('Toronto/Hockey/Korbinian Holzer');
filterData2('Toronto/Hockey/Leo Komarov');
filterData2('Toronto/Hockey/Phil Kessel');
filterData2('Toronto/Hockey/Tyler Bozak');
filterData2('Utah/Basketball/Shelvin Mack');
filterData2('Vancouver/Hockey/Daniel Sedin and Henrik Sedin');
filterData2('Vancouver/Hockey/Daniel Sedin');
filterData2('Vancouver/Hockey/Eric Gudbranson');
filterData2('Vancouver/Hockey/Henrik Sedin Daniel Sedin');
filterData2('Vancouver/Hockey/Henrik Sedin');
filterData2('Vancouver/Hockey/Kevin Bieksa');
filterData2('Vancouver/Hockey/Mattias Ohlund');
filterData2('Vancouver/Hockey/Nick Bonino');
filterData2('Vancouver/Hockey/Radim Vrbata');
filterData2('Washington DC/Baseball/Anthony Rendon');
filterData2('Washington DC/Baseball/Bryce Harper');
filterData2('Washington DC/Baseball/Daniel Murphy');
filterData2('Washington DC/Baseball/Gio Gonzalez');
filterData2('Washington DC/Baseball/Jayson Werth');
filterData2('Washington DC/Baseball/Max Scherzer');
filterData2('Washington DC/Baseball/Ryan Zimmerman');
filterData2('Washington DC/Baseball/Stephen Strasburg');
filterData2('Washington DC/Baseball/Trea Turner');
filterData2('Washington DC/Baseball/Wilson Ramos');
filterData2('Washington DC/Football/Alfred Morris');
filterData2('Washington DC/Football/Brandon Scherff');
filterData2('Washington DC/Football/Chris Thompson');
filterData2('Washington DC/Football/Corey Crawford');
filterData2('Washington DC/Football/Darrel Young');
filterData2('Washington DC/Football/David Amerson');
filterData2('Washington DC/Football/DeAngelo Hall');
filterData2('Washington DC/Football/DeSean Jackson');
filterData2('Washington DC/Football/Deshazor Everett');
filterData2('Washington DC/Football/Josh Doctson');
filterData2('Washington DC/Football/Kirk Cousins');
filterData2('Washington DC/Football/Matt Jones');
filterData2('Washington DC/Football/Morgan Moses');
filterData2('Washington DC/Football/Niles Paul');
filterData2('Washington DC/Football/Pierre Garcon Font');
filterData2('Washington DC/Football/Pierre Garcon');
filterData2('Washington DC/Football/Pierre Garson');
filterData2('Washington DC/Football/Robert Griffin III');
filterData2('Washington DC/Football/Ryan Kerrigan');
filterData2('Washington DC/Football/Sua Cravens');
filterData2('Washington DC/Football/Trent Williams');
filterData2('Washington DC/Hockey/Alex Ovechkin');
filterData2('Washington DC/Hockey/Alexander Ovechkin');
filterData2('Washington DC/Hockey/Braden Holtby');
filterData2('Washington DC/Hockey/Dan Ellis');
filterData2('Washington DC/Hockey/Evgeny Kuznetsov');
filterData2('Washington DC/Hockey/John Carlson');
filterData2('Washington DC/Hockey/Karl Alzner');
filterData2('Washington DC/Hockey/Michael Latta Tom Wilson');
filterData2('Washington DC/Hockey/Michael Latta');
filterData2('Washington DC/Hockey/Mike Green');
filterData2('Washington DC/Hockey/Nicklas Backstrom Alex Ovechkin');
filterData2('Washington DC/Hockey/Nicklas Backstrom');
filterData2('Washington DC/Hockey/Niklas Backstrom');
filterData2('Washington DC/Hockey/Tom Wilson');
filterData2('Washington DC/Hockey/Troy Brouwer');
filterData2('Winnipeg/Hockey/Adam Lowry');
filterData2('Winnipeg/Hockey/Adam Pardy');
filterData2('Winnipeg/Hockey/Anthony Peluso');
filterData2('Winnipeg/Hockey/Ben Chiarot');
filterData2('Winnipeg/Hockey/Blake Wheeler');
filterData2('Winnipeg/Hockey/Bryan Little');
filterData2('Winnipeg/Hockey/Chris Driedger');
filterData2('Winnipeg/Hockey/Drew Stafford');
filterData2('Winnipeg/Hockey/Dustin Byfuglien');
filterData2('Winnipeg/Hockey/Evander Kane');
filterData2('Winnipeg/Hockey/Grant Clitsome');
filterData2('Winnipeg/Hockey/Jacob Trouba');
filterData2('Winnipeg/Hockey/Jay Harrison');
filterData2('Winnipeg/Hockey/Jim Slater');
filterData2('Winnipeg/Hockey/Jiri Tlusty');
filterData2('Winnipeg/Hockey/Mark Scheifele');
filterData2('Winnipeg/Hockey/Mark Stuart');
filterData2('Winnipeg/Hockey/Mathieu Perreault');
filterData2('Winnipeg/Hockey/Matt Halischuk');
filterData2('Winnipeg/Hockey/Michael Frolik');
filterData2('Winnipeg/Hockey/Michael Hutchinson');
filterData2('Winnipeg/Hockey/Ondrej Pavelec');
filterData2('Winnipeg/Hockey/Paul Postma');
filterData2('Winnipeg/Hockey/TJ Galiardi');
filterData2('Winnipeg/Hockey/Toby Enstrom');
filterData2('Winnipeg/Hockey/Tyler Myers');
filterData2('Wrestling/Wrestling/Andre The Giant');
filterData2('Wrestling/Wrestling/Andre the Giant');
filterData2('Wrestling/Wrestling/Brutus The Barber Beefcake');
filterData2('Wrestling/Wrestling/Hacksaw Jim Duggan');
filterData2('Wrestling/Wrestling/Jake The Snake Roberts');
filterData2('Wrestling/Wrestling/Jimmy Snuka');
filterData2('Wrestling/Wrestling/Kevin Nash');
filterData2('Wrestling/Wrestling/Macho Man Randy Savage');
filterData2('Wrestling/Wrestling/Raven');
filterData2('Wrestling/Wrestling/Road Warriors');
filterData2('Wrestling/Wrestling/Rowdy Roddy Piper');
filterData2('Wrestling/Wrestling/Ted DiBiase');
filterData2('Wrestling/Wrestling/The British Bulldog');
